<!-- <ion-header>
  <ion-toolbar>
    <ion-title>
      Blank
    </ion-title>
  </ion-toolbar>
</ion-header> -->

<ion-content [ngClass]="{ 'gridx': profileString === 'gridx', 'galleria610': profileString === 'galleria610', 'sro': profileString === 'sro', 'white': profileString === 'white' }" [style.--background]="(formData.eventBackgroundURI || formData.organizerProfileBackground) ? 'url(' + (formData.eventBackgroundURI || formData.organizerProfileBackground) + ') no-repeat center center / cover' : null">
  <!-- <ion-content> -->
  <div class="wallpaper" id="gridxWallpaper">
    <div class="wallpaper__shroud" id="wallpaper-shroud"></div>
  </div>
  <ion-progress-bar *ngIf="!isFormLoaded || recordingUser" [value]="progress"></ion-progress-bar>

  <!-- Organizer logo -->
  <div id="logoContainer">
    <img *ngIf="profileString === 'gridx'" src="https://firebasestorage.googleapis.com/v0/b/one-evenement.appspot.com/o/platform%2Fgridx_black_logo.png?alt=media&token=4504671a-bf10-4d22-a0c2-2a212150c448">
    <img *ngIf="profileString === 'galleria610'" src="https://firebasestorage.googleapis.com/v0/b/one-evenement.appspot.com/o/platform%2FgalleriaFakeLogo.png?alt=media&token=6b3a5077-c0d1-4add-9fa5-2666ee1fdb13">
    <img *ngIf="profileString === 'sro'" src="https://firebasestorage.googleapis.com/v0/b/one-evenement.appspot.com/o/platform%2Flogo_sro.png?alt=media&token=7115ba63-8653-44aa-a6f1-4e887cc55c15">
    <img *ngIf="profileString === 'white' && (formData.eventLogoURI || formData.organizerProfileLogo)" [src]="formData.eventLogoURI || formData.organizerProfileLogo">
  </div>

  <!-- <div id="skeletonContainer"> -->
  <div *ngIf="!isFormLoaded && !isTwoManyLoginAttemps && molliePaymentStatus !== 'paid' && molliePaymentStatus !== 'askForRefund'" id="skeletonContainer">
    <ion-grid>
      <ion-list-header>
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
      </ion-list-header>
      <!-- <ion-grid> -->
      <ion-row *ngFor="let i of [].constructor(3); let j = index">
        <ion-col size="6">
          <ion-skeleton-text class="skeletonLabel" style="width: 60%;" [animated]="true"></ion-skeleton-text>
          <ion-skeleton-text class="skeletonDescription" style="width: 80%;" [animated]="true"></ion-skeleton-text>
          <ion-skeleton-text class="skeletonDescription" style="width: 40%;" [animated]="true"></ion-skeleton-text>
        </ion-col>
        <ion-col size="2">
          <!-- <ion-skeleton-text class="skeletonLabel" style="width: 50%;" [animated]="true"></ion-skeleton-text> -->
        </ion-col>
        <ion-col size="1">
          <ion-skeleton-text class="skeletonRound" [animated]="true"></ion-skeleton-text>
        </ion-col>
        <ion-col size="2" class="ion-text-center">
          <!-- <ion-skeleton-text class="skeletonLabel" style="width: 50%;" [animated]="true"></ion-skeleton-text> -->
        </ion-col>
        <ion-col size="1">
          <ion-skeleton-text class="skeletonRound" [animated]="true"></ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ion-grid>
    <!-- </ion-list> -->
  </div>

  <div class="formContainer ion-padding" *ngIf="!isFormLoaded && isTwoManyLoginAttemps">
    <ion-fab class="languages-fab" vertical="top" horizontal="end">
      <ion-fab-button color="light" size="small">
        <span *ngIf="selectedLanguage === 'fr'" class="fi fi-fr"></span>
        <span *ngIf="selectedLanguage === 'en'" class="fi fi-gb"></span>
        <span *ngIf="selectedLanguage === 'de'" class="fi fi-de"></span>
        <span *ngIf="selectedLanguage === 'nl'" class="fi fi-nl"></span>
        <!-- <ion-icon name="language-outline"></ion-icon> -->
      </ion-fab-button>
      <ion-fab-list side="bottom">
        <ion-fab-button *ngFor="let lang of ['fr', 'en', 'de', 'nl']" (click)="setLanguage(lang)">
          <span *ngIf="lang === 'fr'" class="fi fi-fr"></span>
          <span *ngIf="lang === 'en'" class="fi fi-gb"></span>
          <span *ngIf="lang === 'de'" class="fi fi-de"></span>
          <span *ngIf="lang === 'nl'" class="fi fi-nl"></span>
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab>

    <ion-card>
      <ion-card-header>
        <ion-card-title>{{ 'TWO_MANY_LOGIN_ATTEMPTS_CARD.TITLE' | translate }}</ion-card-title>
        <ion-card-subtitle>{{ 'TWO_MANY_LOGIN_ATTEMPTS_CARD.SUBTITLE' | translate }}</ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <ion-spinner name="crescent"></ion-spinner>
        <p *ngIf="twoManyLoginAttemptsTimer > 0">{{ 'TWO_MANY_LOGIN_ATTEMPTS_CARD.RETRY_TIMER' | translate: {seconds: twoManyLoginAttemptsTimer} }}</p>
      </ion-card-content>

      <div *ngIf="formData.clientId !== 'tf1Z0TxhbSbpQMzWsAjE'" class="disclaimer">
        <a *ngIf="selectedLanguage === 'fr'" class="disclaimer__link" href="https://welkom.eu" rel="noopener" target="_blank">&nbsp;{{ 'GENERIC.TICKETING_SECURED' | translate }}&nbsp;</a>
        <a *ngIf="selectedLanguage !== 'fr'" class="disclaimer__link" href="https://welkom.eu/en" rel="noopener" target="_blank">&nbsp;{{ 'GENERIC.TICKETING_SECURED' | translate }}&nbsp;</a>
      </div>
    </ion-card>
  </div>

  <div class="formContainer ion-padding" [class.seatingEnabledContainer]="step === '1' && formData.seatingEnabled" *ngIf="isFormLoaded && !isFormSubmissionRecorded">
    <ion-fab *ngIf="formData.eventLanguages && formData.eventLanguages.length > 1" class="languages-fab" vertical="top" horizontal="end">
      <ion-fab-button color="light" size="small">
        <span *ngIf="selectedLanguage === 'fr'" class="fi fi-fr"></span>
        <span *ngIf="selectedLanguage === 'en'" class="fi fi-gb"></span>
        <span *ngIf="selectedLanguage === 'de'" class="fi fi-de"></span>
        <span *ngIf="selectedLanguage === 'nl'" class="fi fi-nl"></span>
        <!-- <ion-icon name="language-outline"></ion-icon> -->
      </ion-fab-button>
      <ion-fab-list side="bottom">
        <ion-fab-button *ngFor="let lang of formData.eventLanguages" (click)="setLanguage(lang)">
          <span *ngIf="lang === 'fr'" class="fi fi-fr"></span>
          <span *ngIf="lang === 'en'" class="fi fi-gb"></span>
          <span *ngIf="lang === 'de'" class="fi fi-de"></span>
          <span *ngIf="lang === 'nl'" class="fi fi-nl"></span>
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab>

    <!-- Description popup fab button -->
    <ion-fab *ngIf="formData.descriptionEnabled === true && formData.descriptionDisplayType === 'popup' && hasDescriptionForCurrentLanguage" class="description-fab" vertical="top" horizontal="end">
      <ion-fab-button (click)="isDescriptionModalOpen = true" color="light" size="small">
        <ion-icon name="information-circle-outline"></ion-icon>
      </ion-fab-button>
    </ion-fab>

    <ion-card *ngIf="molliePaymentStatus === 'crm_subscribed'">
      <img [src]="formData.bannerURI">
      <ion-card-header>
        <ion-card-title>{{ 'CRM_SUBSCRIBED.TITLE' | translate }}</ion-card-title>
      </ion-card-header>

      <ion-card-content>
        <p>{{ 'CRM_SUBSCRIBED.CONTENT.LINE1' | translate }}</p>
        <p>{{ 'CRM_SUBSCRIBED.CONTENT.LINE2' | translate }}</p>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="molliePaymentStatus === 'crm_unsubscribed'">
      <img [src]="formData.bannerURI">
      <ion-card-header>
        <ion-card-title>{{ 'CRM_UNSUBSCRIBED.TITLE' | translate }}</ion-card-title>
      </ion-card-header>

      <ion-card-content>
        <p>{{ 'CRM_UNSUBSCRIBED.CONTENT.LINE1' | translate }}</p>
        <p>{{ 'CRM_UNSUBSCRIBED.CONTENT.LINE2' | translate }}</p>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="molliePaymentStatus === 'redirected'">
      <img [src]="formData.bannerURI">
      <ion-card-header *ngIf="!mollieCheckingStatusFailed">
        <ion-card-title>{{ 'CHECK_PAYMENT_CARD.TITLE' | translate }}</ion-card-title>
        <ion-card-subtitle>{{ 'CHECK_PAYMENT_CARD.SUBTITLE' | translate }}</ion-card-subtitle>
      </ion-card-header>
      <ion-card-header *ngIf="mollieCheckingStatusFailed">
        <ion-card-title>{{ 'CHECK_PAYMENT_CARD.SERVER_ERROR_TITLE' | translate }}</ion-card-title>
        <ion-card-subtitle>{{ 'CHECK_PAYMENT_CARD.SERVER_ERROR_SUBTITLE' | translate }}</ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <ion-spinner *ngIf="!mollieCheckingStatusFailed" name="crescent"></ion-spinner>
        <p *ngIf="mollieCheckinStatusErrorCode === 'order-not-found'" [innerHTML]="'CHECK_PAYMENT_CARD.CONTENT' | translate: { mollieTransactionToken: mollieTransactionToken }"></p>
        <p *ngIf="mollieCheckingStatusFailed">{{ 'CHECK_PAYMENT_CARD.RETRY_OR_CONTACT' | translate }}</p>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="molliePaymentStatus === 'failed'">
      <img [src]="formData.bannerURI">
      <ion-card-header>
        <ion-card-title>{{ 'PAYMENT_FAILED_CARD.TITLE' | translate }}</ion-card-title>
        <ion-card-subtitle>Transaction ID: {{ molliePaymentId }}</ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <p><strong>{{ 'PAYMENT_FAILED_CARD.CONTENT.LINE1' | translate }}</strong></p>
        <p>{{ 'PAYMENT_FAILED_CARD.CONTENT.LINE2' | translate }}</p>
        <p>{{ 'PAYMENT_FAILED_CARD.CONTENT.LINE3' | translate }}</p>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="molliePaymentStatus === 'banktransfer-pending'">
      <img [src]="formData.bannerURI">
      <ion-card-header>
        <ion-card-title>{{ 'BANKTRANSFER_PENDING_CARD.TITLE' | translate }}</ion-card-title>
        <ion-card-subtitle>Transaction ID: {{ molliePaymentId }}</ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <p><strong>{{ 'BANKTRANSFER_PENDING_CARD.CONTENT.LINE1' | translate }}</strong></p>
        <p>{{ 'BANKTRANSFER_PENDING_CARD.CONTENT.LINE2' | translate }}</p>
        <ion-list *ngIf="mollieBankTransfer" lines="full">
          <ion-item>
            <ion-label>
              <p>{{ 'BANKTRANSFER_PENDING_CARD.DETAILS.AMOUNT' | translate }}</p>
              <h3>{{ molliePaidValue | number:'1.2-2' }}€</h3>
            </ion-label>
          </ion-item>
          <ion-item *ngIf="mollieBankTransfer.bankName">
            <ion-label>
              <p>{{ 'BANKTRANSFER_PENDING_CARD.DETAILS.BENEFICIARY' | translate }}</p>
              <h3>{{ mollieBankTransfer.bankName }}</h3>
            </ion-label>
          </ion-item>
          <ion-item *ngIf="mollieBankTransfer.bankAccount">
            <ion-label>
              <p>IBAN</p>
              <h3>{{ mollieBankTransfer.bankAccount }}</h3>
            </ion-label>
          </ion-item>
          <ion-item *ngIf="mollieBankTransfer.bankBic">
            <ion-label>
              <p>BIC</p>
              <h3>{{ mollieBankTransfer.bankBic }}</h3>
            </ion-label>
          </ion-item>
          <ion-item *ngIf="mollieBankTransfer.transferReference">
            <ion-label>
              <p>{{ 'BANKTRANSFER_PENDING_CARD.DETAILS.REFERENCE' | translate }}</p>
              <h3>{{ mollieBankTransfer.transferReference }}</h3>
            </ion-label>
          </ion-item>
        </ion-list>
        <p *ngIf="mollieBankTransfer?.transferReference"><strong>{{ 'BANKTRANSFER_PENDING_CARD.CONTENT.REFERENCE_WARNING' | translate }}</strong></p>
        <p [innerHTML]="'BANKTRANSFER_PENDING_CARD.CONTENT.LINE3' | translate: { mollieEmail: mollieEmail }"></p>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="molliePaymentStatus === 'paid'">
      <img [src]="formData.bannerURI">
      <ion-card-header *ngIf="molliePaidValue > 0">
        <ion-card-title>{{ 'SUCCESS_CARD.TITLE_WITH_PAYMENT' | translate }}</ion-card-title>
        <ion-card-subtitle>Transaction ID: {{ molliePaymentId }}</ion-card-subtitle>
      </ion-card-header>
      <ion-card-header *ngIf="molliePaidValue === 0">
        <ion-card-title>{{ 'SUCCESS_CARD.TITLE_NO_PAYMENT' | translate }}</ion-card-title>
        <ion-card-subtitle>
          <span *ngIf="isTicketDelivered">{{ 'SUCCESS_CARD.SUBTITLE_NO_PAYMENT_WITH_TICKET' | translate }}</span>
          <span *ngIf="!isTicketDelivered">{{ 'SUCCESS_CARD.SUBTITLE_NO_PAYMENT_WITHOUT_TICKET' | translate }}</span>
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content *ngIf="molliePaidValue > 0">
        <p *ngIf="isTicketDelivered"><strong>{{ 'SUCCESS_CARD.CONTENT_WITH_PAYMENT_LINE1_WITH_TICKET' | translate }}</strong></p>
        <p *ngIf="!isTicketDelivered"><strong>{{ 'SUCCESS_CARD.CONTENT_WITH_PAYMENT_LINE1_WITHOUT_TICKET' | translate }}</strong></p>
        <p *ngIf="isTicketDelivered" [innerHTML]="'SUCCESS_CARD.CONTENT_WITH_PAYMENT_LINE2_WITH_TICKET' | translate: { molliePaidValue: molliePaidValue | number:'1.2-2', mollieEmail: mollieEmail }"></p>
        <p *ngIf="!isTicketDelivered" [innerHTML]="'SUCCESS_CARD.CONTENT_WITH_PAYMENT_LINE2_WITHOUT_TICKET' | translate: { molliePaidValue: molliePaidValue | number:'1.2-2', mollieEmail: mollieEmail }"></p>
      </ion-card-content>
      <ion-card-content *ngIf="molliePaidValue === 0">
        <p *ngIf="isTicketDelivered" [innerHTML]="'SUCCESS_CARD.CONTENT_NO_PAYMENT_WITH_TICKET' | translate: { mollieEmail: mollieEmail }"></p>
        <p *ngIf="!isTicketDelivered" [innerHTML]="'SUCCESS_CARD.CONTENT_NO_PAYMENT_WITHOUT_TICKET' | translate: { mollieEmail: mollieEmail }"></p>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="molliePaymentStatus === 'askForRefund'">
      <img [src]="formData.bannerURI">
      <ion-card-header>
        <ion-card-title>{{ 'REFUND_CARD.TITLE' + refundCardModeKeySuffix | translate }}</ion-card-title>
        <ion-card-subtitle *ngIf="!mollieCheckingStatusFailed || mollieCheckinStatusErrorCode !== 'refund-not-enabled'">{{ 'REFUND_CARD.SUBTITLE' | translate: { mollieOrderId: mollieOrderId } }}</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content *ngIf="mollieCheckingStatusFailed">
        <p *ngIf="mollieCheckinStatusErrorCode === 'refund-not-enabled'">
          {{ 'REFUND_CARD.NOT_AVAILABLE' | translate }}
        </p>
        <p *ngIf="mollieCheckinStatusErrorCode !== 'refund-not-enabled'">
          {{ 'CHECK_PAYMENT_CARD.RETRY_OR_CONTACT' | translate }}
        </p>
      </ion-card-content>
      <ng-container *ngIf="!mollieCheckingStatusFailed">
        <ion-card-content *ngIf="isRefundPolicyExpired">
          <p [innerHTML]="'REFUND_CARD.CONTENT_EXPIRED' + refundCardModeKeySuffix | translate: { organizerMail: formData.organizerMail }"></p>
          <!-- <br /> -->
          <!-- <p>For more information, please contact us at <a href="mailto:{{formData.organizerMail}}">{{formData.organizerMail}}</a>.</p> -->
        </ion-card-content>
        <ion-card-content *ngIf="!isRefundPolicyExpired">
          <p *ngIf="!isAllTicketsAlreadyRefunded()" [innerHTML]="'REFUND_CARD.CONTENT_NOT_EXPIRED' + refundCardModeKeySuffix | translate: { mollieEmail: mollieEmail }"></p>
          <p *ngIf="isAllTicketsAlreadyRefunded()" style="font-weight: 500; font-size: 1rem; color: var(--ion-color-success); display: flex; align-items: center; gap: 8px; margin-bottom: 16px;">
            <ion-icon name="checkmark-circle" color="success" style="font-size: 1.3rem;"></ion-icon>
            <span>{{ (isFreeReservation ? 'REFUND_CARD.ALL_CANCELLED' : 'REFUND_CARD.ALL_REFUNDED') | translate }}</span>
          </p>

          <div style="margin-top: 20px; margin-bottom: 20px;">
            <h5 style="font-weight: 600; font-size: 1.1rem; margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
              <ion-icon name="ticket-outline" color="primary"></ion-icon>
              {{ 'REFUND_CARD.CHOOSE_TICKETS' + refundCardModeKeySuffix | translate }}
            </h5>

            <!-- Select All / Deselect All links -->
            <div *ngIf="!isAllTicketsAlreadyRefunded()" style="display: flex; gap: 16px; margin-bottom: 12px; font-size: 0.9rem;">
              <a style="cursor: pointer; text-decoration: none; font-weight: 500;" (click)="toggleAllRefundTickets(true)">
                {{ 'REFUND_CARD.SELECT_ALL' | translate }}
              </a>
              <span style="color: var(--ion-color-medium);">|</span>
              <a style="cursor: pointer; text-decoration: none; font-weight: 500;" (click)="toggleAllRefundTickets(false)">
                {{ 'REFUND_CARD.DESELECT_ALL' | translate }}
              </a>
            </div>

            <!-- List of Tickets/Add-ons -->
            <ion-list lines="full" style="background: transparent; border-radius: 8px; overflow: hidden; border: 1px solid var(--ion-color-light); margin-bottom: 16px;">
              <ion-item *ngFor="let ticket of refundTickets" style="--background: var(--ion-color-step-50);">
                <ion-checkbox slot="start" [checked]="selectedRefundTickets[ticket.id]" (ionChange)="toggleRefundTicket(ticket, $event)" [disabled]="ticket.isFullyDisabled || (ticket.isGiftCard && ticket.isGiftCardPromoCodeUsed)"></ion-checkbox>
                <ion-label style="margin-top: 8px; margin-bottom: 8px;">
                  <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                    <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
                      <span style="font-weight: 600; font-size: 1rem; color: var(--ion-color-dark);">
                        {{ getTicketLabel(ticket) }}
                      </span>
                      <ion-badge *ngIf="ticket.isCombinedTicket" color="warning" style="font-weight: 500; font-size: 0.7rem; padding: 2px 6px;">
                        {{ 'REFUND_CARD.COMBINED_TICKET' | translate }}
                      </ion-badge>
                    </div>
                    <span style="font-weight: 700; font-size: 1rem; color: var(--ion-color-primary);">
                      {{ ticket.ticketPrice | number:'1.2-2' }}€
                    </span>
                  </div>
                  <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 4px; font-size: 0.85rem; color: var(--ion-color-medium);">
                    <span>{{ ticket.userName || mollieFullName }}</span>
                    <ion-badge *ngIf="ticket.isRefunded || ticket.isPartiallyRefunded" color="danger" style="font-weight: 500; font-size: 0.75rem;">
                      <span *ngIf="ticket.isPartiallyRefunded; else normalRefund">
                        {{ 'REFUND_CARD.PARTIALLY_REFUNDED' | translate: { amount: ticket.refundedAmount | number:'1.2-2' } }}
                      </span>
                      <ng-template #normalRefund>
                        {{ 'REFUND_CARD.ALREADY_REFUNDED' | translate }}
                      </ng-template>
                    </ion-badge>
                    <ion-badge *ngIf="ticket.isExchanged" color="danger" style="font-weight: 500; font-size: 0.75rem;">
                      {{ 'REFUND_CARD.EXCHANGED' | translate }}
                    </ion-badge>
                    <ion-badge *ngIf="!ticket.isRefunded && !ticket.isPartiallyRefunded && !ticket.isExchanged && ticket.isCanceled" color="danger" style="font-weight: 500; font-size: 0.75rem;">
                      {{ 'REFUND_CARD.CANCELLED' | translate }}
                    </ion-badge>
                    <ion-badge *ngIf="ticket.isGiftCard && ticket.isGiftCardPromoCodeUsed" color="danger" style="font-weight: 500; font-size: 0.75rem;">
                      {{ 'REFUND_CARD.GIFT_CARD_USED' | translate }}
                    </ion-badge>
                  </div>
                  <div *ngIf="refundSeatingEnabled && ticket.seatLabel" style="display: flex; align-items: center; margin-top: 6px; font-size: 0.85rem;">
                    <span style="background: rgba(var(--ion-color-primary-rgb), 0.1); color: var(--ion-color-primary); padding: 2px 6px; border-radius: 4px; font-size: 0.75rem; font-weight: 600; display: inline-flex; align-items: center;">
                      {{ 'REFUND_CARD.SEAT' | translate }}: {{ ticket.seatLabel }}
                    </span>
                  </div>
                  <div *ngIf="ticket.isPartiallyRefunded" style="margin-top: 6px; font-size: 0.8rem; color: var(--ion-color-danger); font-style: italic; font-weight: 500;">
                    {{ 'REFUND_CARD.PARTIAL_REFUND_BLOCKED' | translate: { amount: ticket.refundedAmount | number:'1.2-2' } }}
                  </div>
                  <div *ngIf="ticket.isCanceled && !ticket.isRefunded && !ticket.isPartiallyRefunded && ticket.canceledReason" style="margin-top: 6px; font-size: 0.8rem; color: var(--ion-color-medium); font-style: italic;">
                    {{ 'REFUND_CARD.CANCEL_REASON' | translate: { reason: ticket.canceledReason } }}
                  </div>
                </ion-label>
              </ion-item>
            </ion-list>

            <!-- Total refund estimation box -->
            <div *ngIf="isEventRefundable && !isFreeReservation && !isAllTicketsAlreadyRefunded()" style="margin-top: 16px; padding: 12px 16px; background: rgba(var(--ion-color-primary-rgb), 0.08); border-radius: 8px; border: 1px solid rgba(var(--ion-color-primary-rgb), 0.15);">
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <span style="font-size: 0.95rem; color: var(--ion-color-dark);" [innerHTML]="'REFUND_CARD.TOTAL_REFUND' | translate: { amount: selectedRefundAmount | number:'1.2-2' }">
                </span>
              </div>
              <ng-container *ngIf="totalFixedFee > 0">
                <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 8px;">
                  <span style="font-size: 0.9rem; color: var(--ion-color-medium);">
                    {{ 'REFUND_CARD.FIXED_FEE' | translate: { count: selectedFeeUnitCount, unitAmount: fixedRefundFeeAmount | number:'1.2-2' } }}
                  </span>
                  <span style="font-weight: 600; font-size: 0.95rem; color: var(--ion-color-danger);">
                    - {{ totalFixedFee | number:'1.2-2' }}€
                  </span>
                </div>
                <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 8px; padding-top: 8px; border-top: 1px solid rgba(var(--ion-color-primary-rgb), 0.15);">
                  <span style="font-weight: 700; font-size: 0.95rem; color: var(--ion-color-dark);">
                    {{ 'REFUND_CARD.NET_REFUND' | translate }}
                  </span>
                  <span style="font-weight: 700; font-size: 1.1rem; color: var(--ion-color-primary);">
                    {{ netRefundAmount | number:'1.2-2' }}€
                  </span>
                </div>
              </ng-container>
            </div>

            <ion-button *ngIf="isEventExchangeable && !isFreeReservation && !isAllTicketsAlreadyRefunded()" id="exchangeButton" (click)="confirmExchange()" [disabled]="!isAnyTicketSelected()" fill="outline" color="primary" size="default" expand="block" style="margin-top: 16px;">
              <ion-icon name="swap-horizontal-outline" slot="start"></ion-icon>
              {{ 'REFUND_CARD.EXCHANGE_BUTTON_TEXT' | translate }}
            </ion-button>

            <ion-button *ngIf="isEventRefundable && !isAllTicketsAlreadyRefunded()" id="refundButton" (click)="confirmRefund()" [disabled]="!isAnyTicketSelected()" fill="solid" size="default" expand="block" style="margin-top: 12px;">
              <ion-icon [name]="isFreeReservation ? 'close-circle-outline' : 'refresh-circle-outline'" slot="start"></ion-icon>
              {{ (isFreeReservation ? 'REFUND_CARD.CANCEL_RESERVATION_BUTTON_TEXT' : 'REFUND_CARD.BUTTON_TEXT') | translate }}
            </ion-button>
          </div>
        </ion-card-content>
      </ng-container>
    </ion-card>

    <ion-card *ngIf="isFormClosed && molliePaymentStatus !== 'paid' && molliePaymentStatus !== 'askForRefund' && molliePaymentStatus !== 'redirected' && molliePaymentStatus !== 'failed' && molliePaymentStatus !== 'banktransfer-pending' && molliePaymentStatus !== 'crm_subscribed' && molliePaymentStatus !== 'crm_unsubscribed'">
      <img [src]="formData.bannerURI">
      <ion-card-header>
        <ion-card-title>{{ 'FORM_CLOSE_CARD.TITLE' | translate }}</ion-card-title>
        <ion-card-subtitle>{{ formData.eventName }}</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <p [innerHTML]="'FORM_CLOSE_CARD.CONTENT' | translate: { organizerMail: formData.organizerMail }"></p>
        <!-- <br /> -->
        <!-- <p>For more information, please contact us at <a href="mailto:{{formData.organizerMail}}">{{formData.organizerMail}}</a>.</p> -->
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="!isFormClosed && molliePaymentStatus !== 'paid' && molliePaymentStatus !== 'askForRefund' && molliePaymentStatus !== 'redirected' && molliePaymentStatus !== 'failed' && molliePaymentStatus !== 'banktransfer-pending' && molliePaymentStatus !== 'crm_subscribed' && molliePaymentStatus !== 'crm_unsubscribed'">
      <img [src]="formData.bannerURI">
      <ion-segment [(ngModel)]="step" [ngModelOptions]="{standalone: true}" (ionChange)="stepChanged($event)" id="stepSegment" [disabled]="true" [scrollable]="true">
        <ion-segment-button *ngIf="formData.descriptionEnabled === true && formData.descriptionDisplayType === 'tab' && hasDescriptionForCurrentLanguage" value="0">{{ 'SEGMENTS.DESCRIPTION' | translate }}</ion-segment-button>
        <ion-segment-button *ngIf="!isSingleFreeTicketFlow" value="1">{{ 'SEGMENTS.TICKETS' | translate }}</ion-segment-button>
        <ion-segment-button *ngIf="filteredAddOns.length > 0" value="2"><span *ngIf="formData.clientId === 'YDF2tDE8FCLJB4Hlt9bP'">{{ 'SEGMENTS.LNDS_ADDONS_TITLE' | translate }}</span><span *ngIf="formData.clientId !== 'YDF2tDE8FCLJB4Hlt9bP'">{{ 'SEGMENTS.ADDONS' | translate }}</span></ion-segment-button>
        <ion-segment-button value="3">{{ 'SEGMENTS.USER_INFO' | translate }}</ion-segment-button>
        <ion-segment-button *ngIf="!isSingleFreeTicketFlow" value="4">{{ 'SEGMENTS.CONFIRMATION' | translate }}</ion-segment-button>
      </ion-segment>
      <ion-progress-bar [value]="stepProgress"></ion-progress-bar>
      <!-- Timer (Globally visible) -->
      <div *ngIf="reservationId" class="ion-text-center ion-margin-top ion-margin-bottom">
        <ion-chip color="warning" (mouseenter)="showReservationPopover($event)">
          <ion-icon name="time-outline"></ion-icon>
          <ion-label id="reservationTimerCountdown">{{ 'GENERIC.RESERVATION_EXPIRES_IN' | translate }} {{ reservationCountdown }}</ion-label>
          <ion-icon #reservationInfoIcon name="information-circle-outline" style="cursor: pointer; margin-left: 8px;">
          </ion-icon>
        </ion-chip>
      </div>

      <!-- Exchange in progress: lets the customer drop it and start a brand new order -->
      <div *ngIf="isExchangeMode && exchangeState && step !== '4'" class="exchangeInProgressBanner">
        <ion-icon name="swap-horizontal-outline" color="primary"></ion-icon>
        <ion-label>{{ 'REFUND_CARD.EXCHANGE_IN_PROGRESS' | translate: { count: exchangeState.originalTickets?.length || 0 } }}</ion-label>
        <ion-button fill="outline" size="small" (click)="cancelExchange()">
          {{ 'REFUND_CARD.START_NEW_ORDER' | translate }}
        </ion-button>
      </div>

      <!-- Description Tab Content -->
      <div *ngIf="step === '0'">
        <!-- <ion-card-header>
          <ion-card-title>{{ 'DESCRIPTION.TITLE' | translate }}</ion-card-title>
        </ion-card-header> -->
        <ion-card-content>
          <div class="descriptionContent" [innerHTML]="safeDescriptionHtml"></div>
          <br />
          <div class="ion-text-right ion-margin-top ion-margin-bottom">
            <ion-button *ngIf="isSingleFreeTicketFlow" id="validateRegistrationButton" (click)="goToStep3()" fill="solid" size="small">
              {{ 'GENERIC.VALIDATE_REGISTRATION' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
            </ion-button>
            <ion-button *ngIf="!isSingleFreeTicketFlow" id="nextStepButton" (click)="goToStep1()" fill="solid" size="small">
              {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
            </ion-button>
          </div>
        </ion-card-content>
      </div>

      <!-- Date promotions shared by standard tickets and seat map categories. -->
      <ng-template #datePromotionBanners>
        <ng-container *ngIf="activeDatePromotionBanners as banners">
          <ng-container *ngFor="let banner of banners.slice(0, 2); trackBy: trackByDatePromotionGroup">
            <ng-container *ngTemplateOutlet="datePromotionCard; context: { $implicit: banner }"></ng-container>
          </ng-container>
          <details *ngIf="banners.length > 2" class="datePromotionMore">
            <summary>{{ 'DATE_PROMOTION.MORE_OFFERS' | translate: { count: banners.length - 2 } }}</summary>
            <ng-container *ngFor="let banner of banners.slice(2); trackBy: trackByDatePromotionGroup">
              <ng-container *ngTemplateOutlet="datePromotionCard; context: { $implicit: banner }"></ng-container>
            </ng-container>
          </details>
        </ng-container>
      </ng-template>

      <!-- Date offers reuse the package discount card and show all affected categories. -->
      <ng-template #datePromotionCard let-banner>
        <div class="familyDiscountBanner datePromotionBanner" [class.active]="banner.key === highlightedDatePromotionKey" [style.--banner-accent]="banner.color" [style.--banner-accent-text]="banner.textColor">
          <div class="familyDiscountBannerHeader">
            <span class="familyDiscountBannerEyebrow">
              <span class="familyDiscountBannerDot"></span>
              <span class="familyDiscountBannerEyebrowText">{{ banner.label }}</span>
            </span>
            <span class="familyDiscountBannerBadge">−{{ banner.percentage }}%</span>
          </div>
          <div class="datePromotionCategories">
            <span *ngFor="let category of banner.categories" class="datePromotionCategory">
              <span class="datePromotionCategoryDot" [style.background-color]="category.color"></span>
              <span>{{ category.ticketTypeLabel }}</span>
            </span>
          </div>
          <div *ngIf="formData.seatingEnabled && ticketStep === 'typeSelection'" class="familyDiscountBannerActions">
            <button type="button" class="familyDiscountBannerCta" (click)="highlightDatePromotion(banner)">
              <span>{{ 'FAMILY_DISCOUNT.CTA' | translate }}</span>
              <span class="familyDiscountBannerCtaArrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" fill="none" />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </ng-template>

      <!-- Price tag rows of a ticket type (multiple ticket types and price steps) -->
      <ng-template #priceTagRows let-tt>
        <p class="date-promotion-notice" *ngIf="!selectedDate && getTicketDatePromotionNotice(tt) as notice">{{ notice }}</p>
        <app-price-row *ngIf="isEarlyBirdActiveForTicket(tt)" [quantity]="tt.priceSelection?.['early-bird'] || 0" [locked]="tt.isSoldOut" (decrement)="removePriceSelection('early-bird', tt)" (increment)="addPriceSelection('early-bird', tt)">
          <span rowLabel>{{ 'GENERIC.EARLY-BIRD' | translate }}</span>
          <span rowPrice *ngIf="tt.isFree && getFreeLabel(tt)">{{ getFreeLabel(tt) }}</span>
          <span rowPrice *ngIf="!tt.isFree">{{ getTicketDisplayPrice(tt, tt.earlyBirdPrice) | number:'1.2-2' }}€</span>
        </app-price-row>
        <app-price-row *ngIf="!isEarlyBirdActiveForTicket(tt) && !tt.isGroupTicketOnly" [quantity]="tt.priceSelection?.['normal'] || 0" [locked]="tt.isSoldOut" (decrement)="removePriceSelection('normal', tt)" (increment)="addPriceSelection('normal', tt)">
          <span rowLabel>{{ formId === 'wFAn8gOhNJuDH12tYKYX' && !isMultipleTicketsAllowed ? 'Tarif 12+' : getLocalizedNormalPriceLabel(tt) }}</span>
          <span rowPrice *ngIf="tt.isFree && getFreeLabel(tt)">{{ getFreeLabel(tt) }}</span>
          <span rowPrice *ngIf="!tt.isFree">{{ getTicketDisplayPrice(tt, tt.price) | number:'1.2-2' }}€</span>
        </app-price-row>
        <app-price-row *ngIf="tt.isStudentDiscount" [quantity]="tt.priceSelection?.['student'] || 0" [locked]="tt.isSoldOut" (decrement)="removePriceSelection('student', tt)" (increment)="addPriceSelection('student', tt)">
          <span rowLabel>{{ 'TICKET_PRICES.STUDENT' | translate }}</span>
          <span rowPrice>{{ getTicketDisplayPrice(tt, tt.studentPrice) | number:'1.2-2' }}€</span>
        </app-price-row>
        <app-price-row *ngIf="tt.isChildrenDiscount" [quantity]="tt.priceSelection?.['children'] || 0" [locked]="tt.isSoldOut" (decrement)="removePriceSelection('children', tt)" (increment)="addPriceSelection('children', tt)">
          <span rowLabel>{{ getLocalizedChildrenPriceLabel(tt) }}</span>
          <span rowPrice>{{ getTicketDisplayPrice(tt, tt.childrenPrice) | number:'1.2-2' }}€</span>
          <span rowNote *ngIf="!tt.childrenMaxAge">{{ 'TICKET_PRICES.CHILDREN_WARNING_1' | translate: { age: tt.childrenAge } }}</span>
          <span rowNote *ngIf="tt.childrenMaxAge && !tt.childrenMinAge">{{ 'TICKET_PRICES.CHILDREN_WARNING_2' | translate: { maxAge: tt.childrenMaxAge } }}</span>
          <span rowNote *ngIf="tt.childrenMaxAge && tt.childrenMinAge">{{ 'TICKET_PRICES.CHILDREN_WARNING_3' | translate: { minAge: tt.childrenMinAge, maxAge: tt.childrenMaxAge } }}</span>
        </app-price-row>
        <app-price-row *ngIf="tt.isYouthDiscount" [quantity]="tt.priceSelection?.['youth'] || 0" [locked]="tt.isSoldOut" (decrement)="removePriceSelection('youth', tt)" (increment)="addPriceSelection('youth', tt)">
          <span rowLabel>{{ getLocalizedYouthPriceLabel(tt) }}</span>
          <span rowPrice>{{ getTicketDisplayPrice(tt, tt.youthPrice) | number:'1.2-2' }}€</span>
          <span rowNote *ngIf="!tt.youthMaxAge">{{ 'TICKET_PRICES.YOUTH_WARNING_1' | translate: { age: tt.youthAge } }}</span>
          <span rowNote *ngIf="tt.youthMaxAge && !tt.youthMinAge">{{ 'TICKET_PRICES.YOUTH_WARNING_2' | translate: { maxAge: tt.youthMaxAge } }}</span>
          <span rowNote *ngIf="tt.youthMaxAge && tt.youthMinAge">{{ 'TICKET_PRICES.YOUTH_WARNING_3' | translate: { minAge: tt.youthMinAge, maxAge: tt.youthMaxAge } }}</span>
        </app-price-row>
        <app-price-row *ngIf="tt.isSeniorDiscount" [quantity]="tt.priceSelection?.['senior'] || 0" [locked]="tt.isSoldOut" (decrement)="removePriceSelection('senior', tt)" (increment)="addPriceSelection('senior', tt)">
          <span rowLabel>{{ getLocalizedSeniorPriceLabel(tt) }}</span>
          <span rowPrice>{{ getTicketDisplayPrice(tt, tt.seniorPrice) | number:'1.2-2' }}€</span>
          <span rowNote>{{ 'TICKET_PRICES.SENIOR_WARNING' | translate: { minAge: tt.seniorMinAge } }}</span>
        </app-price-row>
        <app-price-row *ngIf="tt.isDisabledDiscount" [quantity]="tt.priceSelection?.['disabled'] || 0" [locked]="tt.isSoldOut" (decrement)="removePriceSelection('disabled', tt)" (increment)="addPriceSelection('disabled', tt)">
          <span rowLabel>{{ getLocalizedDisabledPriceLabel(tt) }}</span>
          <span rowPrice>{{ getTicketDisplayPrice(tt, tt.disabledPrice) | number:'1.2-2' }}€</span>
          <span rowNote>{{ 'TICKET_PRICES.DISABLED_WARNING' | translate }}</span>
        </app-price-row>
        <app-price-row *ngIf="tt.isFamilyGroup" [quantity]="tt.priceSelection?.['family-group'] || 0" [locked]="tt.isSoldOut" (decrement)="removePriceSelection('family-group', tt)" (increment)="addPriceSelection('family-group', tt)">
          <span rowLabel>{{ 'TICKET_PRICES.FAMILY_GROUP' | translate }}</span>
          <span rowPrice>{{ getTicketDisplayPrice(tt, tt.familyGroupBasePrice) | number:'1.2-2' }}€ {{ 'TICKET_PRICES.FAMILY_GROUP_BASE' | translate }}</span>
          <span rowNote>{{ getTicketDisplayPrice(tt, tt.familyGroupExtraTicketPrice) | number:'1.2-2' }}€ {{ 'TICKET_PRICES.FAMILY_GROUP_EXTRA' | translate }}</span>
        </app-price-row>
        <app-price-row *ngIf="tt.isRegularGroup" [quantity]="tt.priceSelection?.['regular-group'] || 0" [locked]="tt.isSoldOut" (decrement)="removePriceSelection('regular-group', tt)" (increment)="addPriceSelection('regular-group', tt)">
          <span rowLabel>{{ (isReallyNexusClient ? 'TICKET_PRICES.NEXUS_REGULAR_GROUP' : 'TICKET_PRICES.REGULAR_GROUP') | translate }}</span>
          <span rowPrice>{{ getTicketDisplayPrice(tt, tt.regularGroupBasePrice) | number:'1.2-2' }}€ {{ 'TICKET_PRICES.REGULAR_GROUP_BASE' | translate: { regularGroupBaseTickets: tt.regularGroupBaseTickets } }}</span>
          <span rowNote *ngIf="isReallyNexusClient">{{ 'TICKET_PRICES.NEXUS_REGULAR_GROUP_WARNING' | translate }}</span>
          <span rowNote *ngIf="!isReallyNexusClient">{{ getTicketDisplayPrice(tt, tt.regularGroupExtraTicketPrice) | number:'1.2-2' }}€ {{ 'TICKET_PRICES.REGULAR_GROUP_EXTRA' | translate }}</span>
        </app-price-row>
      </ng-template>

      <!-- Step 1 - Seat map events: tickets or gift cards -->
      <div *ngIf="step === '1' && ticketStep === 'purchaseChoice'">
        <ion-card-header class="ticket-header">
          <div class="header-titles">
            <ion-card-title>{{ 'SEAT_MAP_GIFT_CARDS.CHOICE_TITLE' | translate }}</ion-card-title>
            <ion-card-subtitle>{{ 'SEAT_MAP_GIFT_CARDS.CHOICE_SUBTITLE' | translate }}</ion-card-subtitle>
          </div>
        </ion-card-header>

        <ion-card-content id="ticketTypesContainer">
          <app-choice-card [selectable]="true" [selected]="seatMapPurchaseMode === 'tickets'" (activate)="chooseSeatMapTickets()">
            <span cardTitle>{{ 'SEAT_MAP_GIFT_CARDS.TICKETS' | translate }}</span>
            <span cardDescription>{{ 'SEAT_MAP_GIFT_CARDS.TICKETS_DESCRIPTION' | translate }}</span>
          </app-choice-card>
          <app-choice-card [selectable]="true" [selected]="isGiftCardMode" (activate)="chooseSeatMapGiftCards()">
            <span cardTitle>{{ 'SEAT_MAP_GIFT_CARDS.GIFT_CARDS' | translate }}</span>
            <span cardDescription>{{ 'SEAT_MAP_GIFT_CARDS.GIFT_CARDS_DESCRIPTION' | translate }}</span>
          </app-choice-card>

          <ion-grid>
            <ion-row class="ion-align-items-center">
              <ion-col size="6">
                <ion-button *ngIf="isDescriptionTabActive" id="backButton" (click)="goToStep0()" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon><span>{{ 'GENERIC.BACK' | translate }}</span>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </div>

      <!-- Step 1 - Seat map events: gift cards and their quantities -->
      <div *ngIf="step === '1' && ticketStep === 'giftCardSelection'">
        <ion-card-header class="ticket-header">
          <div class="header-titles">
            <ion-card-title>{{ 'SEAT_MAP_GIFT_CARDS.GIFT_CARDS' | translate }}</ion-card-title>
            <ion-card-subtitle>{{ 'SEAT_MAP_GIFT_CARDS.GIFT_CARDS_SUBTITLE' | translate }}</ion-card-subtitle>
          </div>
        </ion-card-header>

        <ion-card-content id="ticketTypesContainer">
          <app-choice-card *ngFor="let ticketType of giftCardTicketTypes; trackBy: trackByTicketTypeId" [accent]="ticketType.color || null" [soldOut]="!!ticketType.isSoldOut" [soldOutLabel]="'TICKET_TYPES.SOLD_OUT' | translate" [remaining]="ticketType.remaining">
            <span cardTitle>{{ getLocalizedLabelFromTicketType(ticketType) }}</span>
            <span cardDescription *ngIf="getLocalizedDescriptionFromTicketType(ticketType)" [innerHTML]="getLocalizedDescriptionFromTicketType(ticketType) | linkify"></span>
            <ng-container *ngIf="!ticketType.isSoldOut">
              <ng-container *ngTemplateOutlet="priceTagRows; context: { $implicit: ticketType }"></ng-container>
            </ng-container>
          </app-choice-card>

          <app-order-total *ngIf="totalTicketTypePrice > 0 || !isPriceSelected" [groups]="ticketRecapGroups" [amount]="totalTicketTypePrice - automaticDiscountTotal" [originalAmount]="automaticDiscountTotal > 0 ? totalTicketTypePrice : null" [vat]="automaticTicketVAT"></app-order-total>

          <ion-grid>
            <ion-row class="ion-align-items-center ion-margin-top">
              <ion-col size="6">
                <ion-button *ngIf="hasSeatMapPurchaseChoice || isDescriptionTabActive" id="backButton" (click)="onGiftCardSelectionBack()" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon> {{ 'GENERIC.BACK' | translate }}
                </ion-button>
              </ion-col>
              <ion-col size="6" class="alignRight">
                <!-- Next button if no bookable gift cards or already booked -->
                <ion-button *ngIf="getBookableItems().length === 0 || reservationId" id="nextButton" (click)="goToStep3()" fill="solid" size="small" [disabled]="!isPriceSelected && !reservationId">
                  {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                </ion-button>
                <!-- Limited gift cards: book temporary -->
                <ion-button *ngIf="!reservationId && isPriceSelected && getBookableItems().length > 0" color="secondary" fill="solid" (click)="bookTemporaryTickets()" size="small" class="ion-margin-start">
                  {{ 'GENERIC.BOOK_TEMPORARY' | translate }}&nbsp;<ion-icon name="ticket-outline"></ion-icon>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </div>

      <!-- Step 1 Content -->
      <div *ngIf="step === '1' && ticketStep === 'typeSelection'">
        <ion-card-header *ngIf="!formData.seatingEnabled" class="ticket-header">
          <div class="header-titles">
            <ion-card-title>{{ 'TICKET_TYPES.TITLE' | translate }}</ion-card-title>
            <ion-card-subtitle>{{ 'TICKET_TYPES.SUBTITLE' | translate }}</ion-card-subtitle>
          </div>
        </ion-card-header>
        <ion-card-header *ngIf="formData.seatingEnabled" class="ticket-header">
          <div class="header-titles">
            <ion-card-title>{{ 'TICKET_TYPES.SEAT_TITLE' | translate }}</ion-card-title>
            <ion-card-subtitle>{{ 'TICKET_TYPES.SEAT_SUBTITLE' | translate }}</ion-card-subtitle>
          </div>
        </ion-card-header>

        <ion-card-content id="ticketTypesContainer" *ngIf="!formData.seatingEnabled">
          <!-- One ticket type -->
          <div *ngIf="!isMultipleTicketsAllowed">
            <app-choice-card *ngFor="let ticketType of ticketTypes; trackBy: trackByTicketTypeId" [accent]="ticketType.color || null" [accentText]="ticketType.color ? getReadableTextColor(ticketType.color) : null" [selectable]="true" [selected]="!!ticketType.isSelected" [soldOut]="!!ticketType.isSoldOut" [soldOutLabel]="'TICKET_TYPES.SOLD_OUT' | translate" [offer]="getComplimentaryOfferLabel(ticketType)" [remaining]="ticketType.remaining" (activate)="toggleTicketSelection(ticketType)">
              <span cardTitle>{{ getLocalizedLabelFromTicketType(ticketType) }}</span>
              <span cardDescription class="date-promotion-notice" *ngIf="!selectedDate && getTicketDatePromotionNotice(ticketType) as notice">{{ notice }}</span>
              <span cardPrice *ngIf="ticketType.isFree && getFreeLabel(ticketType)">{{ getFreeLabel(ticketType) }}</span>
              <span cardPrice *ngIf="!ticketType.isFree && ticketType.lowestPrice !== ticketType.highestPrice">{{ 'TICKET_TYPES.FROM' | translate }} {{ getTicketDisplayPrice(ticketType, ticketType.lowestPrice!) | number:'1.2-2' }}€ {{ 'TICKET_TYPES.TO' | translate }} {{ getTicketDisplayPrice(ticketType, ticketType.highestPrice!) | number:'1.2-2' }}€</span>
              <span cardPrice *ngIf="!ticketType.isFree && ticketType.lowestPrice === ticketType.highestPrice">{{ getTicketDisplayPrice(ticketType, ticketType.highestPrice!) | number:'1.2-2' }}€</span>
              <span cardDescription *ngIf="getDisplayDescription(ticketType)" [innerHTML]="getDisplayDescription(ticketType) | linkify"></span>
            </app-choice-card>

            <ion-grid>
              <ion-row class="ion-align-items-center">
                <ion-col size="6">
                  <ion-button *ngIf="isDescriptionTabActive || (formData.seatingEnabled && eventHasDateSelection())" id="backButton" (click)="onTicketSelectionBack()" fill="solid" size="small">
                    <ion-icon name="arrow-back-outline"></ion-icon><span>{{ 'GENERIC.BACK' | translate }}</span>
                  </ion-button>
                </ion-col>
                <ion-col size="6" class="alignRight">
                  <ion-button id="nextButton" (click)="goToPriceSelection()" fill="solid" size="small" [disabled]="!isTicketSelected">
                    {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>

          <!-- Several ticket types: quantities per price tag -->
          <div *ngIf="isMultipleTicketsAllowed">
            <app-choice-card *ngFor="let ticketType of ticketTypes; trackBy: trackByTicketTypeId" [accent]="ticketType.color || null" [soldOut]="!!ticketType.isSoldOut" [soldOutLabel]="'TICKET_TYPES.SOLD_OUT' | translate" [offer]="getComplimentaryOfferLabel(ticketType)" [remaining]="ticketType.remaining">
              <span cardTitle>{{ getLocalizedLabelFromTicketType(ticketType) }}</span>
              <span cardDescription *ngIf="getLocalizedDescriptionFromTicketType(ticketType)" [innerHTML]="getLocalizedDescriptionFromTicketType(ticketType) | linkify"></span>
              <ng-container *ngIf="!ticketType.isSoldOut">
                <ng-container *ngTemplateOutlet="priceTagRows; context: { $implicit: ticketType }"></ng-container>
              </ng-container>
            </app-choice-card>

            <app-order-total *ngIf="totalTicketTypePrice > 0 || (!isPriceSelected && !allTicketTypesAreFree)" [groups]="ticketRecapGroups" [amount]="totalTicketTypePrice - automaticDiscountTotal" [originalAmount]="automaticDiscountTotal > 0 ? totalTicketTypePrice : null" [vat]="automaticTicketVAT"></app-order-total>

            <ion-grid>
              <ion-row class="ion-align-items-center ion-margin-top">
                <ion-col size="6">
                  <ion-button *ngIf="isDescriptionTabActive" id="backButton" (click)="goToStep0()" fill="solid" size="small">
                    <ion-icon name="arrow-back-outline"></ion-icon> {{ 'GENERIC.BACK' | translate }}
                  </ion-button>
                </ion-col>
                <ion-col size="6" class="alignRight">
                  <!-- Next button if add-ons exist -->
                  <ion-button *ngIf="filteredAddOns.length > 0" id="nextButton" (click)="goToStep2()" fill="solid" size="small" [disabled]="!isPriceSelected">
                    {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                  </ion-button>
                  <!-- Next button if no add-ons and no bookable items or already booked -->
                  <ion-button *ngIf="filteredAddOns.length <= 0 && (getBookableItems().length === 0 || reservationId)" id="nextButton" (click)="goToStep3()" fill="solid" size="small" [disabled]="!isPriceSelected && !reservationId">
                    {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                  </ion-button>
                  <!-- If no add-ons and bookable items, book temporary -->
                  <ion-button *ngIf="!reservationId && filteredAddOns.length <= 0 && isPriceSelected && getBookableItems().length > 0" color="secondary" fill="solid" (click)="bookTemporaryTickets()" size="small" class="ion-margin-start">
                    {{ 'GENERIC.BOOK_TEMPORARY' | translate }}&nbsp;<ion-icon name="ticket-outline"></ion-icon>
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-card-content>

        <ion-card-content *ngIf="formData.seatingEnabled">
          <ng-container *ngTemplateOutlet="datePromotionBanners"></ng-container>
          <!-- Seat map family discount banners -->
          <div *ngFor="let banner of familyDiscountBanners" class="familyDiscountBanner" [class.active]="banner.ticketTypeId === highlightedSeatMapTicketTypeId" [style.--banner-accent]="banner.color" [style.--banner-accent-text]="banner.textColor">
            <div class="familyDiscountBannerHeader">
              <span class="familyDiscountBannerEyebrow">
                <span class="familyDiscountBannerDot"></span>
                <span class="familyDiscountBannerEyebrowText">{{ banner.label }} · {{ 'CONFIRMATION.FAMILY_DISCOUNT_APPLIED' | translate }}</span>
              </span>
              <span class="familyDiscountBannerBadge">-{{ banner.percentage }}%</span>
            </div>
            <div class="familyDiscountBannerContent" [innerHTML]="banner.html"></div>
            <div class="familyDiscountBannerActions">
              <button type="button" class="familyDiscountBannerCta" (click)="highlightFamilyDiscountTicketType(banner.ticketTypeId)">
                <span>{{ 'FAMILY_DISCOUNT.CTA' | translate }}</span>
                <span class="familyDiscountBannerCtaArrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" fill="none" />
                  </svg>
                </span>
              </button>
            </div>
          </div>

          <!-- Selected seats breakdown (family discount applied as soon as the combination is selected) -->
          <div class="selection-summary-inline" *ngIf="selectedSeats.length > 0">
            <div class="summary-items">
              <div class="summary-item-group" *ngFor="let item of selectedSeatsSummary; trackBy: trackBySummaryKey">
                <div class="summary-item-inline">
                  <span class="item-dot" [style.background-color]="item.color"></span>
                  <span class="item-label">{{ item.name }} x{{ item.count }}</span>
                </div>
                <div class="summary-seat-chips">
                  <span class="summary-seat-chip" *ngFor="let seat of item.seats; trackBy: trackBySeatId">
                    <span class="seat-chip-label"><ng-container *ngIf="seat.blockName">{{ seat.blockName }} · </ng-container>{{ 'TICKET_PRICES.SEAT_LOCATION' | translate: { row: seat.row, col: seat.number } }}</span>
                    <span class="seat-chip-tag">{{ seat.priceTagLabel }}</span>
                    <button type="button" class="seat-chip-remove" (click)="removeSelectedSeat(seat.id)" [attr.aria-label]="'SEAT_MAP_CART.REMOVE_SEAT' | translate" [title]="'SEAT_MAP_CART.REMOVE_SEAT' | translate">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="3" stroke-linecap="round" fill="none" />
                      </svg>
                    </button>
                  </span>
                </div>
                <ng-container *ngFor="let promotion of datePromotionApplications">
                  <div *ngIf="promotion.ticketTypeId === item.key" class="summary-item-inline family-discount-applied">
                    <span class="item-label">{{ getDatePromotionLabel(promotion) }} −{{ promotion.percentage }}% : −{{ promotion.amount | number:'1.2-2' }}€</span>
                  </div>
                </ng-container>
                <!-- Package discount of this ticket type -->
                <ng-container *ngFor="let familyDiscount of familyDiscountApplications">
                  <div *ngIf="familyDiscount.ticketTypeId === item.key" class="summary-item-inline family-discount-applied">
                    <span class="item-label">{{ 'CONFIRMATION.FAMILY_DISCOUNT_APPLIED' | translate }} -{{ familyDiscount.percentage }}% : -{{ familyDiscount.amount | number:'1.2-2' }}€</span>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="summary-total-inline">
              <div class="summary-totals">
                <span *ngIf="automaticDiscountTotal > 0" class="total-price-original">{{ (totalSelectedSeatsPrice | number:'1.2-2') }}€</span>
                <span class="total-price">{{ ((totalSelectedSeatsPrice - automaticDiscountTotal) | number:'1.2-2') }}€</span>
              </div>
              <button type="button" class="empty-cart-button" (click)="emptySelectedSeats()">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
                </svg>
                <span>{{ 'SEAT_MAP_CART.EMPTY' | translate }}</span>
              </button>
            </div>
          </div>

          <app-seat-map-viewer #seatMapViewer [config]="filteredSeatingConfig" [ticketTypes]="seatMapTicketTypes" [soldSeats]="soldSeats" [unavailableTicketTypeIds]="unavailableSeatMapTicketTypeIds" [selectedLanguage]="selectedLanguage" [initialSelectedSeats]="selectedSeats" (seatSelected)="onSeatSelected($event)" [highlightedTicketTypeIds]="highlightedSeatMapTicketTypeIds" [highlightTitle]="seatMapHighlightTitle" [highlightCaption]="seatMapHighlightCaption" [highlightCaptionItems]="seatMapHighlightCaptionItems" [highlightApplied]="isHighlightedSeatMapDiscountApplied" [highlightCloseLabel]="'FAMILY_DISCOUNT.CLOSE' | translate" (highlightCleared)="clearSeatMapHighlight()" (highlightRequested)="onSeatMapHighlightRequested($event)"></app-seat-map-viewer>

          <ion-grid id="step2ButtonsContainer">
            <ion-row class="ion-align-items-center ion-margin-top">
              <ion-col size="6">
                <ion-button *ngIf="isDescriptionTabActive || eventHasDateSelection() || hasSeatMapPurchaseChoice" id="backButton" (click)="onSeatMapBack()" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon><span>{{ 'GENERIC.BACK' | translate }}</span>
                </ion-button>
              </ion-col>
              <ion-col size="6" class="alignRight">
                <!-- Next button if add-ons exist -->
                <ion-button *ngIf="filteredAddOns.length > 0" id="nextButton" (click)="goToStep2()" fill="solid" size="small" [disabled]="selectedSeats.length === 0">
                  {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                </ion-button>
                <!-- Next button if no add-ons and event has date selection -->
                <ion-button *ngIf="filteredAddOns.length <= 0 && eventHasDateSelection()" id="nextButton" (click)="goToStep3()" fill="solid" size="small" [disabled]="selectedSeats.length === 0">
                  {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                </ion-button>
                <!-- Book tickets button if no add-ons and event does not have date selection -->
                <ion-button *ngIf="filteredAddOns.length <= 0 && !eventHasDateSelection()" color="secondary" fill="solid" (click)="goToStep3()" size="small" [disabled]="selectedSeats.length === 0">
                  {{ 'GENERIC.BOOK_TEMPORARY' | translate }}&nbsp;<ion-icon name="ticket-outline"></ion-icon>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </div>

      <div *ngIf="step === '1' && ticketStep === 'priceSelection'">
        <ion-card-header>
          <!-- <ion-card-title>{{ selectedTicketType.label }}</ion-card-title> -->
          <ion-card-title *ngIf="!selectedTicketType.label[selectedLanguage] && (!formData.eventDefaultLanguage || !selectedTicketType.label[formData.eventDefaultLanguage])" class="ticketTypeLabel">{{ selectedTicketType.label }}</ion-card-title>
          <ion-card-title *ngIf="!selectedTicketType.label[selectedLanguage] && selectedTicketType.label[formData.eventDefaultLanguage]" class="ticketTypeLabel">{{ selectedTicketType.label[formData.eventDefaultLanguage] }}</ion-card-title>
          <ion-card-title *ngIf="selectedTicketType.label[selectedLanguage]">{{ selectedTicketType.label[selectedLanguage] }}</ion-card-title>

          <ion-card-subtitle>{{ 'TICKET_PRICES.PICK_PRICE' | translate }}</ion-card-subtitle>
        </ion-card-header>

        <ion-card-content id="ticketTypesContainer">
          <app-choice-card [showHeader]="false" [accent]="selectedTicketType.color || null" [soldOut]="!!selectedTicketType.isSoldOut" [soldOutLabel]="'TICKET_TYPES.SOLD_OUT' | translate" [offer]="getComplimentaryOfferLabel(selectedTicketType)" [remaining]="selectedTicketType.remaining">
            <span cardDescription *ngIf="getDisplayDescription(selectedTicketType)" [innerHTML]="getDisplayDescription(selectedTicketType) | linkify"></span>
            <ng-container *ngTemplateOutlet="priceTagRows; context: { $implicit: selectedTicketType }"></ng-container>
          </app-choice-card>

          <app-order-total *ngIf="totalTicketTypePrice > 0 || (!isPriceSelected && !allTicketTypesAreFree)" [groups]="ticketRecapGroups" [amount]="totalTicketTypePrice - automaticDiscountTotal" [originalAmount]="automaticDiscountTotal > 0 ? totalTicketTypePrice : null" [vat]="automaticTicketVAT"></app-order-total>

          <ion-grid>
            <ion-row>
              <ion-col size="6">
                <ion-button *ngIf="!isTypeSelectionSkipped" id="backButton" (click)="goToTypeSelection()" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon> {{ 'GENERIC.BACK' | translate }}
                </ion-button>
                <ion-button *ngIf="isTypeSelectionSkipped && isDescriptionTabActive" id="backButton" (click)="goToStep0(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon> {{ 'GENERIC.BACK' | translate }}
                </ion-button>
              </ion-col>
              <ion-col size="6" class="alignRight">
                <ion-button *ngIf="requiresDateSelection(selectedTicketType) && !isSlotSelected" id="nextButton" (click)="goToDateSelection()" fill="solid" size="small" [disabled]="!isPriceSelected">
                  {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                </ion-button>

                <!-- Next button if add-ons exist -->
                <ng-container *ngIf="!requiresDateSelection(selectedTicketType) || isSlotSelected">
                  <ion-button *ngIf="filteredAddOns.length > 0" id="nextButton" (click)="goToStep2()" fill="solid" size="small" [disabled]="!isPriceSelected">
                    {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                  </ion-button>
                  <!-- Next button if no add-ons and no bookable items or already booked -->
                  <ion-button *ngIf="filteredAddOns.length <= 0 && (getBookableItems().length === 0 || reservationId)" id="nextButton" (click)="goToStep3()" fill="solid" size="small" [disabled]="!isPriceSelected && !reservationId">
                    {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                  </ion-button>
                </ng-container>

                <!-- If no add-ons and bookable items, book temporary -->
                <ion-button *ngIf="!reservationId && filteredAddOns.length <= 0 && isPriceSelected && getBookableItems().length > 0 && !requiresDateSelection(selectedTicketType)" color="secondary" fill="solid" (click)="bookTemporaryTickets()" size="small" class="ion-margin-start">
                  {{ 'GENERIC.BOOK_TEMPORARY' | translate }}&nbsp;<ion-icon name="ticket-outline"></ion-icon>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </div>

      <!-- Step 1 Content -->
      <div *ngIf="step === '1' && ticketStep === 'dateSelection'">
        <ion-card-header>
          <ion-card-title *ngIf="!selectedTicketType.isTimeSlot">{{ 'TIME_SLOTS.TITLE_DATE' | translate }}</ion-card-title>
          <ion-card-title *ngIf="selectedTicketType.isTimeSlot">{{ 'TIME_SLOTS.TITLE_TIME' | translate }}</ion-card-title>
          <ion-card-subtitle>{{ 'TIME_SLOTS.SUBTITLE' | translate }}</ion-card-subtitle>
        </ion-card-header>

        <ion-card-content id="ticketSlotContainer">
          <app-date-slot-picker [min]="openingDateISO" [max]="closingDateISO" [highlightedDates]="highlightedDates" [isDateEnabled]="isDateEnabled" [hasPrivatizedException]="hasPrivatizedException" [hasDatePromotions]="hasDatePromotions" [isTimeSlot]="selectedTicketType.isTimeSlot" [timeSlots]="timeSlots" [selectedDate]="selectedDate" [selectedSlot]="selectedSlotTickets" [reservedQuantity]="selectedTicketTypeCartQuantity" [durationMinutes]="formData.clientId === 'U1gtpSNQhIREVxoer9qB' ? selectedTicketType.timeSlotDuration : null" [accentColor]="selectedTicketTypeCartQuantity > 0 ? (selectedTicketType.color || null) : null" (dateChange)="onSelectedDateChanged($event)" (slotToggle)="toggleTimeSlotSelection($event)"></app-date-slot-picker>
          <ng-container *ngIf="selectedDate && (!selectedTicketType.isTimeSlot || isSlotSelected)">
            <ng-container *ngTemplateOutlet="datePromotionBanners"></ng-container>
          </ng-container>
          <app-order-total *ngIf="!formData.seatingEnabled && selectedDate && isPriceSelected" [groups]="ticketRecapGroups" [amount]="totalTicketTypePrice - automaticDiscountTotal" [originalAmount]="automaticDiscountTotal > 0 ? totalTicketTypePrice : null" [vat]="automaticTicketVAT"></app-order-total>

          <ion-grid>
            <ion-row>
              <ion-col size="6">
                <ion-button *ngIf="!formData.seatingEnabled" id="backButton" (click)="goToPriceSelection()" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon> {{ 'GENERIC.BACK' | translate }}
                </ion-button>
                <ion-button *ngIf="formData.seatingEnabled && isDescriptionTabActive && !hasSeatMapPurchaseChoice" id="backButton" (click)="goToStep0(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon> {{ 'GENERIC.BACK' | translate }}
                </ion-button>
                <ion-button *ngIf="formData.seatingEnabled && hasSeatMapPurchaseChoice" id="backButton" (click)="goToPurchaseChoice()" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon> {{ 'GENERIC.BACK' | translate }}
                </ion-button>
              </ion-col>
              <ion-col *ngIf="filteredAddOns.length > 0" size="6" class="alignRight">
                <!-- If add-ons -->
                <ion-button id="nextButton" (click)="onDateConfirmed()" fill="solid" size="small" [disabled]="!isSlotSelected">
                  {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                </ion-button>
              </ion-col>
              <ion-col *ngIf="filteredAddOns.length <= 0" size="6" class="alignRight">
                <!-- If no add-ons and no bookable items or already booked -->
                <ion-button *ngIf="getBookableItems().length === 0 || reservationId" id="nextButton" (click)="onDateConfirmed()" fill="solid" size="small" [disabled]="!isSlotSelected && !reservationId">
                  {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                </ion-button>

                <!-- If no add-ons and bookable items, book temporary -->
                <ion-button *ngIf="!reservationId && isSlotSelected && getBookableItems().length > 0" color="secondary" fill="solid" (click)="bookTemporaryTickets()" size="small" class="ion-margin-start">
                  {{ 'GENERIC.BOOK_TEMPORARY' | translate }}&nbsp;<ion-icon name="ticket-outline"></ion-icon>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </div>

      <!-- Step 2 Content - ADD-ONS -->
      <div *ngIf="step === '2'">
        <ion-card-header *ngIf="formData.clientId !== 'YDF2tDE8FCLJB4Hlt9bP'">
          <ion-card-title>{{ 'ADD_ONS.TITLE' | translate }}</ion-card-title>
          <ion-card-subtitle>{{ 'ADD_ONS.SUBTITLE' | translate }}</ion-card-subtitle>
        </ion-card-header>
        <ion-card-header *ngIf="formData.clientId === 'YDF2tDE8FCLJB4Hlt9bP'">
          <!-- <ion-card-subtitle>{{ 'ADD_ONS.LNDS_SUBTITLE' | translate }}</ion-card-subtitle> -->
          <p>Book yourself a spot at one or more of the interactive trainings and workshops, taking place parallel to the plenary session. <a href="https://datasummit.lu/programme?track=trainings" target="_blank">See full information about the trainings here</a>. Important: Help us make every seat count. Register only if you plan to attend and notify us promptly if your plans change.</p>
          <ion-card-title>{{ 'ADD_ONS.LNDS_TITLE' | translate }}</ion-card-title>
        </ion-card-header>

        <ion-card-content id="ticketTypesContainer">
          <app-choice-card *ngFor="let addOn of filteredAddOns; trackBy: trackByAddOnId" [accent]="addOn.color || null" [selected]="(addOn.selection || 0) > 0" [soldOut]="!!addOn.isSoldOut" [soldOutLabel]="'ADD_ONS.SOLD_OUT' | translate" [remaining]="addOn.remaining">
            <span cardTitle>{{ getLocalizedLabelFromTicketType(addOn) }}</span>
            <span cardPrice *ngIf="!addOn.isFree">{{ addOn.price | number:'1.2-2' }}€</span>
            <app-quantity-stepper cardAside *ngIf="!addOn.isSoldOut || (addOn.selection || 0) > 0" [quantity]="addOn.selection || 0" (decrement)="removeAddOnSelection(addOn)" (increment)="addAddOnSelection(addOn)"></app-quantity-stepper>
            <span cardDescription *ngIf="getDisplayDescription(addOn)">{{ getDisplayDescription(addOn) }}</span>
          </app-choice-card>

          <!-- Cart: tickets already selected + add-ons -->
          <app-order-total *ngIf="totalPrice > 0 || (!hasSelectedAddOns && !allAvailableAddOnsAreFree)" [groups]="cartRecapGroups" [amount]="totalPrice - automaticDiscountTotal" [originalAmount]="automaticDiscountTotal > 0 ? totalPrice : null" [vat]="totalVATAfterPromotion"></app-order-total>

          <ion-grid>
            <ion-row class="ion-align-items-center">
              <ion-col size="6">
                <ion-button *ngIf="requiresDateSelection(selectedTicketType)" id="backButton" (click)="goToDateSelection()" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon> {{ 'GENERIC.BACK' | translate }}
                </ion-button>
                <ion-button *ngIf="!requiresDateSelection(selectedTicketType)" id="backButton" (click)="goToPriceSelection()" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon> {{ 'GENERIC.BACK' | translate }}
                </ion-button>
              </ion-col>
              <ion-col size="6" class="alignRight">
                <!-- If no bookable items or already booked (non-seated or with date slots) -->
                <ion-button *ngIf="(getBookableItems().length === 0 || reservationId) && !(formData.seatingEnabled && !eventHasDateSelection())" id="nextButton" (click)="goToStep3()" fill="solid" size="small" [disabled]="!isTicketSelected && !reservationId">
                  {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                </ion-button>

                <!-- Book tickets button if no bookable items or already booked (seated and without date slots) -->
                <ion-button *ngIf="(getBookableItems().length === 0 || reservationId) && (formData.seatingEnabled && !eventHasDateSelection())" color="secondary" fill="solid" (click)="goToStep3()" size="small" [disabled]="!isTicketSelected && !reservationId">
                  {{ 'GENERIC.BOOK_TEMPORARY' | translate }}&nbsp;<ion-icon name="ticket-outline"></ion-icon>
                </ion-button>

                <!-- If bookable items -->
                <ion-button *ngIf="!reservationId && getBookableItems().length > 0" color="secondary" fill="solid" (click)="bookTemporaryTickets()" size="small" class="ion-margin-start">
                  {{ 'GENERIC.BOOK_TEMPORARY' | translate }}&nbsp;<ion-icon name="ticket-outline"></ion-icon>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </div>

      <!-- Step 2 Content -->
      <div *ngIf="step === '3'">
        <ion-card-header>
          <ion-card-title *ngIf="totalVisitorCount > 0">{{ currentVisitorFormTicketTypeLabel }}</ion-card-title>
          <ion-card-title *ngIf="totalVisitorCount <= 0">{{ 'INPUTS.TITLE' | translate }}</ion-card-title>
          <ion-card-subtitle>{{ (currentEntryIsMultipleVisitorForms && currentVisitorIndex > 0 ? 'INPUTS.NEXUS_PARTICIPANT' : 'INPUTS.NEXUS_BUYER') | translate }}</ion-card-subtitle>
        </ion-card-header>

        <ion-card-content>
          <!-- Ticket X / Y of the ticket type, or the quantity covered by a shared form -->
          <app-form-progress *ngIf="currentEntryIsMultipleVisitorForms || (currentVisitorFormEntry?.cartQuantity || 0) > 1" [accent]="getTicketTypeColor(currentVisitorFormEntry?.ticketTypeId || null)" [current]="currentEntryIsMultipleVisitorForms ? (currentVisitorFormEntry?.formIndexInTicketType || 0) : 0" [total]="currentEntryIsMultipleVisitorForms ? (currentVisitorFormEntry?.ticketTypeQuantity || 0) : 0" [note]="!currentEntryIsMultipleVisitorForms && (currentVisitorFormEntry?.cartQuantity || 0) > 1 ? ('INPUTS.TICKET_TYPE_QUANTITY_NOTE' | translate:{ count: currentVisitorFormEntry?.cartQuantity }) : null"></app-form-progress>

          <form [formGroup]="inputForm" (ngSubmit)="submitForm()" novalidate [class.submitted]="isFormSubmitted">
            <ion-list id="inputsContainer">
              <!-- <ion-list-header>
                <ion-label>Données personnelles</ion-label>
              </ion-list-header> -->

              <ng-template #inputRow let-input>
                <ion-item lines="none" [hidden]="hideBasedOnInputConditions(input)">
                  <ion-icon *ngIf="input.fieldIcon" slot="start" [name]="input.fieldIcon"></ion-icon>
                  <ion-label *ngIf="input.type !== 'checkbox'" position="stacked">{{ getLocalizedLabel(input) }} <span *ngIf="input.isRequired" class="redStar">*</span></ion-label>
                  <ion-input *ngIf="input.type === 'text' && (this.production || (input.fieldName !== 'userFirstname' && input.fieldName !== 'userLastname'))" type="text" [formControlName]="input.fieldName" ngDefaultControl helperText="{{ getLocalizedHelperText(input) }}"></ion-input>
                  <!-- DEVELOPMENT FIELDS -->
                  <ion-input *ngIf="input.type === 'text' && !this.production && input.fieldName === 'userFirstname'" type="text" [formControlName]="input.fieldName" ngDefaultControl helperText="{{ getLocalizedHelperText(input) }}"></ion-input>
                  <ion-input *ngIf="input.type === 'text' && !this.production && input.fieldName === 'userLastname'" type="text" [formControlName]="input.fieldName" ngDefaultControl helperText="{{ getLocalizedHelperText(input) }}"></ion-input>
                  <!------------------------>
                  <ion-textarea *ngIf="input.type === 'textarea'" [formControlName]="input.fieldName" ngDefaultControl helperText="{{ getLocalizedHelperText(input) }}"></ion-textarea>
                  <ion-input *ngIf="input.type === 'number'" type="number" [formControlName]="input.fieldName" (keydown)="cleanNumbersKeydown($event)" ngDefaultControl helperText="{{ getLocalizedHelperText(input) }}"></ion-input>
                  <ion-input *ngIf="input.type === 'tel'" type="tel" [formControlName]="input.fieldName" (keydown)="cleanTelKeydown($event)" ngDefaultControl helperText="{{ getLocalizedHelperText(input) }}"></ion-input>
                  <ion-input *ngIf="input.type === 'email' && this.production" type="email" [formControlName]="input.fieldName" ngDefaultControl helperText="{{ getLocalizedHelperText(input) }}"></ion-input>
                  <!-- DEVELOPMENT FIELD -->
                  <ion-input *ngIf="input.type === 'email' && !this.production" type="email" [formControlName]="input.fieldName" ngDefaultControl helperText="{{ getLocalizedHelperText(input) }}"></ion-input>
                  <!------------------------>
                  <ion-checkbox *ngIf="input.type === 'checkbox'" label-placement="end" [formControlName]="input.fieldName">
                    <span class="ion-text-wrap">{{ getLocalizedLabel(input) }} <span *ngIf="input.isRequired" class="redStar">*</span></span>
                  </ion-checkbox>
                  <ion-note *ngIf="input.type === 'checkbox' && getLocalizedHelperText(input) && getLocalizedHelperText(input).length > 0">{{ getLocalizedHelperText(input) }}</ion-note>

                  <ion-select *ngIf="input.type === 'select' || input.type === 'selectMultiple'" label-placement="stacked" [formControlName]="input.fieldName" [multiple]="input.type === 'selectMultiple'" [interfaceOptions]="{ backdropDismiss: false }" ngDefaultControl>
                    <ion-select-option *ngFor="let option of input.options" [value]="option.value">{{ getLocalizedOptionLabel(option) }}</ion-select-option>
                  </ion-select>
                  <div class="dropdown-line" *ngIf="input.type === 'select' || input.type === 'selectMultiple'"></div>
                  <ion-note *ngIf="(input.type === 'select' || input.type === 'selectMultiple') && getLocalizedHelperText(input) && getLocalizedHelperText(input).length > 0">{{ getLocalizedHelperText(input) }}</ion-note>
                </ion-item>

                <ion-item lines="none" *ngIf="input.type === 'email' && isEmailConfirmationRequiredForCurrentVisitor">
                  <ion-icon slot="start" name="mail-outline"></ion-icon>
                  <ion-label position="stacked">{{ 'INPUTS.CONFIRM_EMAIL' | translate }}<span *ngIf="input.isRequired" class="redStar">*</span></ion-label>
                  <ion-input *ngIf="this.production" type="email" [formControlName]="input.fieldName + '_confirm'" ngDefaultControl (paste)="onPaste($event)" autocomplete="new-password" helperText="{{ getLocalizedHelperText(input) }}"></ion-input>
                  <!-- DEVELOPMENT FIELD -->
                  <ion-input *ngIf="!this.production" type="email" [formControlName]="input.fieldName + '_confirm'" ngDefaultControl autocomplete="new-password" helperText="{{ getLocalizedHelperText(input) }}"></ion-input>
                  <!------------------------>
                </ion-item>

                <ion-item lines="none" *ngIf="isReallyNexusClient && input.firestoreKey === 'email'">
                  <ion-label>
                    <ion-note>{{ 'INPUTS.INFO_EMAIL_NEXUS' | translate }}</ion-note>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" *ngIf="input.type === 'tel' && input.isHidden !== true">
                  <ion-note>{{ 'INPUTS.INFO_TEL' | translate }}</ion-note>
                </ion-item>

                <span class="error" *ngIf="isFormSubmitted && errorControl[input.fieldName].errors?.['required'] && !hideBasedOnInputConditions(input)">
                  '{{ getLocalizedLabel(input) }}' {{ 'INPUTS.IS_REQUIRED' | translate }}
                </span>
                <span class="error" *ngIf="input.type === 'tel' && isFormSubmitted && errorControl[input.fieldName].errors?.['pattern']">
                  {{ 'INPUTS.INVALID_TEL' | translate }}
                </span>

                <span class="error" *ngIf="input.type === 'email' && isFormSubmitted && (errorControl[input.fieldName].errors?.['pattern'] || (isEmailConfirmationRequiredForCurrentVisitor && errorControl[input.fieldName + '_confirm'].errors?.['pattern']))">
                  {{ 'INPUTS.INVALID_EMAIL' | translate }}
                </span>
                <span class="error" *ngIf="input.type === 'email' && input.isPersonalEmailBlocked && isFormSubmitted && isPersonalEmail">
                  {{ 'INPUTS.PROFESSIONAL_EMAIL_REQUIRED' | translate }}
                </span>

                <span class="error" *ngIf="input.type === 'email' && isConfirmEmailAsked && isEmailConfirmationRequiredForCurrentVisitor && checkEmailDifferentError">
                  {{ 'INPUTS.EMAILS_DONT_MATCH' | translate }}
                </span>
              </ng-template>

              <!-- Regular sections: one card each, in the ticket type color -->
              <ng-container *ngIf="formData.sections && formData.sections.length > 0; else flatInputs">
                <ng-container *ngFor="let section of formData.sections">
                  <app-choice-card *ngIf="!section.isAcknowledgments && hasVisibleInputsInSection(section)" [showHeader]="false" [accent]="getTicketTypeColor(currentVisitorFormEntry?.ticketTypeId || null)" [eyebrow]="getLocalizedSectionTitle(section) || null">
                    <div class="formFields">
                      <div *ngFor="let input of section.inputs">
                        <ng-container [ngTemplateOutlet]="inputRow" [ngTemplateOutletContext]="{ $implicit: input }"></ng-container>
                      </div>
                    </div>
                  </app-choice-card>
                </ng-container>
              </ng-container>

              <ng-template #flatInputs>
                <app-choice-card [showHeader]="false" [accent]="getTicketTypeColor(currentVisitorFormEntry?.ticketTypeId || null)">
                  <div class="formFields">
                    <div *ngFor="let input of formData.inputs">
                      <ng-container [ngTemplateOutlet]="inputRow" [ngTemplateOutletContext]="{ $implicit: input }"></ng-container>
                    </div>
                  </div>
                </app-choice-card>
              </ng-template>

              <!-- <ion-item>
                <ion-label position="stacked">Prénom 2</ion-label>
                <ion-input type="text" formControlName="firstname" ngDefaultControl></ion-input>
              </ion-item>
              <span class="error" *ngIf="isFormSubmitted && errorControl['firstname'].errors?.['required']">
                Champ requis
              </span> -->

              <!-- <ion-item lines="none">          
                <ion-checkbox slot="start" color="dark" [(ngModel)]="isAgreementChecked" [ngModelOptions]="{standalone: true}"></ion-checkbox>
                <ion-label class="ion-text-wrap">J'accepte les conditions générales d'utilisation de l'organisateur disponibles sur le site internet <a href="https://welkom.eu" target="_blank"></a>www.welkom.eu</ion-label>
              </ion-item> -->

              <!-- Acknowledgments Section -->
              <app-choice-card *ngIf="!isMultipleVisitorForms || currentVisitorIndex === 0" class="acknowledgmentsSection" [showHeader]="false" [accent]="getTicketTypeColor(currentVisitorFormEntry?.ticketTypeId || null)" [eyebrow]="'INPUTS.ACKNOWLEDGEMENT_TITLE' | translate">
                <div class="formFields">

                  <ion-item lines="none" *ngIf="isWelkomTermsVisible && (!isMultipleVisitorForms || currentVisitorIndex === 0)">
                    <ion-checkbox slot="start" [(ngModel)]="isWelkomAgreementChecked" [ngModelOptions]="{standalone: true}"></ion-checkbox>
                    <ion-label class="ion-text-wrap">
                      {{ 'INPUTS.WELKOM_ACCEPTANCE' | translate }}
                      <a href="#" (click)="$event.preventDefault(); $event.stopPropagation(); isWelkomTermsModalOpen = true">{{ 'GENERIC.HERE' | translate }}</a>
                      <span class="redStar">*</span>
                    </ion-label>
                  </ion-item>
                  <span class="error" *ngIf="(!isMultipleVisitorForms || currentVisitorIndex === 0) && isFormSubmitted && !isWelkomAgreementChecked">
                    {{ 'INPUTS.ACCEPTANCE_REQUIRED' | translate }}
                  </span>

                  <ion-item lines="none" *ngIf="isOrganizerTermsVisible && (!isMultipleVisitorForms || currentVisitorIndex === 0)">
                    <!-- <ion-checkbox justify="start" label-placement="end" [(ngModel)]="isOrganizerAgreementChecked" [ngModelOptions]="{standalone: true}">
                    <span class="ion-text-wrap">{{ 'INPUTS.ORGANIZER_TERMS_ACCEPTANCE' | translate: { organizerName: formData.organizerCommercialName } }} <a [href]="formData.organizerTermsURL" (click)="$event.stopPropagation()" target="_blank">{{ 'GENERIC.HERE' | translate }}</a></span>
                    <span class="redStar">*</span>
                  </ion-checkbox> -->

                    <ion-checkbox slot="start" [(ngModel)]="isOrganizerAgreementChecked" [ngModelOptions]="{standalone: true}"></ion-checkbox>
                    <ion-label class="ion-text-wrap">
                      {{ 'INPUTS.ORGANIZER_TERMS_ACCEPTANCE' | translate: { organizerName: formData.organizerLegalName } }} <a [href]="formData.organizerTermsURL" (click)="$event.stopPropagation()" target="_blank">{{ 'GENERIC.HERE' | translate }}</a>
                      <span class="redStar">*</span>
                    </ion-label>
                  </ion-item>
                  <span class="error" *ngIf="isOrganizerTermsVisible && (!isMultipleVisitorForms || currentVisitorIndex === 0) && isFormSubmitted && !isOrganizerAgreementChecked">
                    {{ 'INPUTS.ACCEPTANCE_REQUIRED' | translate }}
                  </span>

                  <!-- OPTIN -->
                  <div *ngIf="isOptinVisible && (!isMultipleVisitorForms || currentVisitorIndex === 0)">
                    <!-- <ion-item lines="none">
                    <ion-checkbox justify="start" label-placement="end" [(ngModel)]="isOptinChecked" [ngModelOptions]="{standalone: true}">
                      <span class="ion-text-wrap">{{ 'INPUTS.ORGANIZER_OPTIN' | translate: { organizerName: formData.organizerCommercialName } }}</span>
                    </ion-checkbox>
                  </ion-item> -->
                    <ion-item lines="none">
                      <ion-checkbox slot="start" [(ngModel)]="isOptinChecked" [ngModelOptions]="{standalone: true}"></ion-checkbox>
                      <ion-label class="ion-text-wrap">
                        {{ 'INPUTS.ORGANIZER_OPTIN' | translate: { organizerName: formData.organizerCommercialName } }}
                      </ion-label>
                    </ion-item>
                  </div>

                  <div *ngIf="formData.sections">
                    <div *ngFor="let section of formData.sections">
                      <div *ngIf="section.isAcknowledgments && section.inputs.length > 0 && (!isMultipleVisitorForms || currentVisitorIndex === 0)">
                        <!-- <ion-list-header *ngIf="getLocalizedSectionTitle(section)">
                      <ion-label>{{ getLocalizedSectionTitle(section) }}</ion-label>
                    </ion-list-header> -->
                        <div *ngFor="let input of section.inputs">
                          <ion-item lines="none" class="acknowledgment-item" [hidden]="hideBasedOnInputConditions(input)">
                            <!-- <ion-checkbox justify="start" label-placement="end" [formControlName]="input.fieldName">
                            <span class="ion-text-wrap acknowledgment-label">
                              {{ getLocalizedLabel(input) }} <span *ngIf="input.isRequired" class="redStar">*</span>
                            </span>
                          </ion-checkbox> -->

                            <ion-checkbox slot="start" [formControlName]="input.fieldName"></ion-checkbox>
                            <ion-label class="ion-text-wrap">
                              <span class="ion-text-wrap acknowledgment-label" [innerHTML]="getLocalizedLabel(input) | linkify" (click)="$event.stopPropagation()"></span>
                              <span *ngIf="input.isRequired" class="redStar">*</span>
                            </ion-label>
                          </ion-item>
                          <span class="error" *ngIf="isFormSubmitted && errorControl[input.fieldName].errors && !hideBasedOnInputConditions(input)">
                            {{ 'INPUTS.ACCEPTANCE_REQUIRED' | translate }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </app-choice-card>

              <div id="informationsContainer" *ngIf="!isMultipleVisitorForms || currentVisitorIndex === 0">
                <p class="formRequiredNote"><span class="redStar">*</span> {{ 'INPUTS.REQUIRED' | translate }}</p>
                <p>
                  {{ 'INPUTS.GDPR_CONTENT' | translate }} ({{ formData.organizerMail }})
                  <span *ngIf="isReallyNexusClient">
                    <br />
                    The Privacy Policy of Nexus Luxembourg is available <a href="https://www.nexusluxembourg.com/privacy" target="_blank">here</a>.
                  </span>
                </p>
              </div>
            </ion-list>

            <p class="formErrorSummary" role="alert" *ngIf="isFormSubmitted && !inputForm.valid">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 8v5M12 16h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
              </svg>
              <span>{{ 'INPUTS.ERROR_CHECK_FIELDS' | translate }}</span>
            </p>

            <!-- subscribe button -->
            <ion-grid id="step2ButtonsContainer" *ngIf="!isMultipleVisitorForms; else visitorButtons">
              <ion-row>
                <ion-col size="6">
                  <ion-button *ngIf="!isSingleFreeTicketFlow && filteredAddOns.length > 0" id="backButton" (click)="goToStep2(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                    <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.EDIT_ORDER' | translate }}</span>
                  </ion-button>
                  <ion-button *ngIf="!isSingleFreeTicketFlow && filteredAddOns.length <= 0 && requiresDateSelection(selectedTicketType)" id="backButton" (click)="goToDateSelection(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                    <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.EDIT_ORDER' | translate }}</span>
                  </ion-button>
                  <ion-button *ngIf="!isSingleFreeTicketFlow && filteredAddOns.length <= 0 && !requiresDateSelection(selectedTicketType)" id="backButton" (click)="goToPriceSelection(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                    <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.EDIT_ORDER' | translate }}</span>
                  </ion-button>
                  <ion-button *ngIf="isSingleFreeTicketFlow && isDescriptionTabActive" id="backButton" (click)="goToStep0(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                    <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.EDIT_ORDER' | translate }}</span>
                  </ion-button>
                </ion-col>
                <ion-col size="6" class="alignRight">
                  <ion-button *ngIf="!isSingleFreeTicketFlow" id="nextButton" type="submit" fill="solid" size="small">
                    {{ 'GENERIC.NEXT' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                  </ion-button>
                  <ion-button *ngIf="isSingleFreeTicketFlow" id="validateRegistrationButton" type="submit" fill="solid" size="small">
                    {{ 'GENERIC.VALIDATE_REGISTRATION' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon>
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
            <ng-template #visitorButtons>
              <ion-grid id="step2ButtonsContainer">
                <ion-row>
                  <ion-col size="6">
                    <ion-button *ngIf="!isSingleFreeTicketFlow && currentVisitorIndex === 0 && filteredAddOns.length > 0" id="backButton" (click)="goToStep2(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                      <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.EDIT_ORDER' | translate }}</span>
                    </ion-button>
                    <ion-button *ngIf="!isSingleFreeTicketFlow && currentVisitorIndex === 0 && filteredAddOns.length <= 0 && formData.seatingEnabled && !isGiftCardMode" id="backButton" (click)="goToTypeSelection(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                      <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.EDIT_ORDER' | translate }}</span>
                    </ion-button>
                    <ion-button *ngIf="!isSingleFreeTicketFlow && currentVisitorIndex === 0 && isGiftCardMode" id="backButton" (click)="goToGiftCardSelection(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                      <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.EDIT_ORDER' | translate }}</span>
                    </ion-button>
                    <ion-button *ngIf="!isSingleFreeTicketFlow && currentVisitorIndex === 0 && filteredAddOns.length <= 0 && !formData.seatingEnabled && selectedTicketType.isDateSlot" id="backButton" (click)="goToDateSelection(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                      <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.EDIT_ORDER' | translate }}</span>
                    </ion-button>
                    <ion-button *ngIf="!isSingleFreeTicketFlow && currentVisitorIndex === 0 && filteredAddOns.length <= 0 && !formData.seatingEnabled && !selectedTicketType.isDateSlot" id="backButton" (click)="goToPriceSelection(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                      <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.EDIT_ORDER' | translate }}</span>
                    </ion-button>
                    <ion-button *ngIf="currentVisitorIndex === 0 && isSingleFreeTicketFlow && isDescriptionTabActive" id="backButton" (click)="goToStep0(reservationId !== undefined && reservationId !== null)" fill="solid" size="small">
                      <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.EDIT_ORDER' | translate }}</span>
                    </ion-button>
                    <ion-button *ngIf="currentVisitorIndex > 0" id="backButton" (click)="goToVisitor(currentVisitorIndex - 1)" fill="solid" size="small">
                      <ion-icon name="arrow-back-outline"></ion-icon><span *ngIf="!reservationId">{{ 'GENERIC.BACK' | translate }}</span><span *ngIf="reservationId">{{ 'GENERIC.BACK' | translate }}</span>
                    </ion-button>
                  </ion-col>
                  <ion-col size="6" class="alignRight">
                    <ion-button id="nextButton" type="submit" fill="solid" size="small">
                      {{ currentVisitorIndex < (totalVisitorCount - 1) ? ('GENERIC.NEXT' | translate) : ('GENERIC.NEXT' | translate) }} <ion-icon name="arrow-forward-outline"></ion-icon>
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ng-template>
            <!-- <button id="submitButton" type="submit" shape="round" [style.backgroundColor]="formData.buttonColor">
              {{ formData.buttonText }}
            </button> -->

          </form>
        </ion-card-content>
      </div>

      <!-- Step 1 Content -->
      <div *ngIf="step === '4'">
        <ion-card-header>
          <ion-card-title>{{ 'CONFIRMATION.TITLE' | translate }}</ion-card-title>
          <ion-card-subtitle>{{ 'CONFIRMATION.SUBTITLE' | translate }}</ion-card-subtitle>
        </ion-card-header>

        <ion-card-content id="ticketTypesContainer">
          <!-- Order details: email, date, time -->
          <app-order-recap [email]="buyerEmail" [date]="requiresDateSelection(selectedTicketType) ? selectedDate : null" [time]="selectedTicketType.isTimeSlot ? (selectedSlotTickets.displayLabel || selectedSlotTickets.label) : null"></app-order-recap>

          <!-- Tickets -->
          <app-choice-card *ngIf="isMultipleVisitorForms" [showHeader]="false" [showAccentEdge]="false" [eyebrow]="'GENERIC.TICKETS' | translate">
            <ng-container *ngFor="let cartItem of cart">
              <app-cart-line *ngIf="cartItem.ticketTypeId" [accent]="getTicketTypeColor(cartItem.ticketTypeId)" [amount]="cartItem.price * cartItem.quantity" [quantity]="cartItem.quantity" [unitPrice]="cartItem.price">
                <span lineLabel>{{ getLocalizedLabelFromTicketType(cartItem) }}</span>
                <span *ngIf="getCartRecapPriceTagLabel(cartItem) as priceTagLabel" lineTag>{{ priceTagLabel }}</span>
                <span *ngIf="getDisplayDescription(cartItem) as description">{{ description }}</span>
                <span *ngIf="formData.seatingEnabled && cartItem.seat">
                  <ion-icon name="location-outline" aria-hidden="true" style="vertical-align: middle; margin-right: 4px;"></ion-icon>
                  <ng-container *ngIf="formData.seatingConfig?.hasFloors && cartItem.seat.floor > 0">{{ 'CONFIRMATION.SEAT_FLOOR' | translate }} <strong>{{ cartItem.seat.floor }}</strong> · </ng-container>
                  {{ 'CONFIRMATION.SEAT_BLOCK' | translate }} <strong>{{ cartItem.seat.blockName }}</strong> · {{ 'CONFIRMATION.SEAT_ROW' | translate }} <strong>{{ cartItem.seat.row }}</strong> · {{ 'CONFIRMATION.SEAT_NUMBER' | translate }} <strong>{{ cartItem.seat.number }}</strong>
                  <ng-container *ngIf="cartItem.seat.isDisabledAccessible">
                    · <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 0.9em; height: 0.9em; vertical-align: middle; margin-right: 2px;">
                      <path fill="currentColor" d="M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm272 368-76.3-138.8c-7.9-14.4-23-23.2-39.3-23.2H240v-80h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24h99.7l54 98.2c7.6 13.9 25.2 18.9 39.1 11.3s18.9-25.2 11.3-39.1zM281.6 376c-17.9 37.9-56.3 64-100.8 64-61.9 0-112-50.1-112-112 0-54.7 39.2-99.8 91.2-109.8 13.1-2.5 21.7-15.2 19.2-28.3s-15.2-21.7-28.3-19.2C71 184.8 16 247.4 16 328c0 97.2 78.8 176 176 176 72.8 0 135.5-44.3 162.7-107.5 5.2-12.2-.4-26.3-12.6-31.5s-26.3.4-31.5 12.6z" />
                    </svg>{{ 'CONFIRMATION.SEAT_DISABLED_ACCESSIBLE' | translate }}
                  </ng-container>
                </span>
                <ng-container *ngFor="let visitor of cartItem.visitors; let visitorIndex = index">
                  <span *ngIf="isPerUnitVisitorForm(cartItem)">#{{ visitorIndex + 1 }} · {{ visitor.fullName }} · {{ visitor.email }}</span>
                  <span *ngIf="!isPerUnitVisitorForm(cartItem) && visitorIndex === 0">{{ visitor.fullName }} · {{ visitor.email }}</span>
                </ng-container>
                <span *ngIf="isLastCartItemForTicketType(cartItem) && getComplimentaryTicketQuantity(getCartTicketTypeQuantity(cartItem), cartItem) as complimentaryQuantity" lineNote>
                  {{ getComplimentaryTranslationKey('CONFIRMATION.COMPLIMENTARY_TICKET_SUMMARY', getCartTicketTypeQuantity(cartItem), complimentaryQuantity) | translate: {
                  purchased: getCartTicketTypeQuantity(cartItem),
                  free: complimentaryQuantity,
                  total: getIssuedTicketQuantity(getCartTicketTypeQuantity(cartItem), cartItem)
                  } }}
                </span>
              </app-cart-line>
            </ng-container>
          </app-choice-card>

          <!-- Add-ons -->
          <app-choice-card *ngIf="cartHasAddOns" [showHeader]="false" [showAccentEdge]="false" [eyebrow]="'GENERIC.ADD_ONS' | translate">
            <ng-container *ngFor="let cartItem of cart">
              <app-cart-line *ngIf="cartItem.addOnId" [accent]="getAddOnColor(cartItem.addOnId)" [amount]="cartItem.price * cartItem.quantity" [quantity]="cartItem.quantity" [unitPrice]="cartItem.price">
                <span lineLabel>{{ getLocalizedLabelFromTicketType(cartItem) }}</span>
                <span *ngIf="getDisplayDescription(cartItem) as description">{{ description }}</span>
              </app-cart-line>
            </ng-container>
          </app-choice-card>

          <!-- Total: package discounts, promo code, promo code action -->
          <app-order-total *ngIf="totalPrice > 0 || !isPriceSelected" [groups]="confirmationDiscountGroups" [amount]="hasAppliedPromotion ? totalPriceAfterPromotion : totalPrice" [originalAmount]="hasAppliedPromotion ? totalPrice : null" [vat]="hasAppliedPromotion ? totalVATAfterPromotion : totalVAT" [actionLabel]="showPromoCodeButton && (hasAppliedPromotion ? totalPriceAfterPromotion : totalPrice) > 0.01 ? ('CONFIRMATION.ANY_PROMO_CODE' | translate) : null" (action)="askForPromoCode()"></app-order-total>

          <!-- Exchange summary -->
          <app-choice-card *ngIf="isExchangeMode && exchangeState" class="exchangeSummary" [showHeader]="false" [showAccentEdge]="false" [eyebrow]="'CONFIRMATION.EXCHANGE_SUMMARY_TITLE' | translate">
            <app-cart-line [marker]="false" [amount]="exchangeState.originalValue || 0" sign="-" tone="success">
              <span lineLabel>{{ 'CONFIRMATION.EXCHANGE_CREDIT' | translate }}</span>
            </app-cart-line>
            <!-- Fixed fee withheld from the exchange credit -->
            <app-cart-line *ngIf="exchangeFixedFee > 0" [marker]="false" [amount]="exchangeFixedFee" sign="+">
              <span lineLabel>{{ 'CONFIRMATION.EXCHANGE_FEE' | translate: { count: exchangeState.originalTickets.length, unitAmount: fixedRefundFeeAmount | number:'1.2-2' } }}</span>
            </app-cart-line>
            <!-- Net difference -->
            <app-cart-line [marker]="false" [emphasis]="true" [amount]="exchangeNetDifference > 0.01 ? exchangeNetDifference : (exchangeNetDifference < -0.01 ? -exchangeNetDifference : 0)" [tone]="exchangeNetDifference > 0.01 ? 'primary' : (exchangeNetDifference < -0.01 ? 'success' : 'medium')">
              <span *ngIf="exchangeNetDifference > 0.01" lineLabel>{{ 'CONFIRMATION.DIFFERENCE_TO_PAY' | translate }}</span>
              <span *ngIf="exchangeNetDifference < -0.01" lineLabel>{{ 'CONFIRMATION.DIFFERENCE_TO_REFUND' | translate }}</span>
              <span *ngIf="exchangeNetDifference >= -0.01 && exchangeNetDifference <= 0.01" lineLabel>{{ 'CONFIRMATION.EXCHANGE_EQUAL' | translate }}</span>
            </app-cart-line>
          </app-choice-card>

          <ion-grid>
            <ion-row>
              <ion-col size="4">
                <ion-button id="backButton" (click)="goToStep3()" fill="solid" size="small">
                  <ion-icon name="arrow-back-outline"></ion-icon> {{ 'GENERIC.BACK' | translate }}
                </ion-button>
              </ion-col>
              <ion-col size="8" class="alignRight">
                <ion-button *ngIf="paymentRequired" id="nextButton" type="submit" fill="solid" (click)="proceedWithPayment()" size="small">
                  {{ 'CONFIRMATION.PROCEED_WITH_PAYMENT' | translate }}&nbsp;<ion-icon name="card-outline"></ion-icon>
                </ion-button>
                <ion-button *ngIf="!paymentRequired" id="nextButton" type="submit" fill="solid" (click)="registerForTheEvent()" size="small">
                  {{ 'CONFIRMATION.PROCEED_WITHOUT_PAYMENT' | translate }}&nbsp;<ion-icon name="checkmark-outline"></ion-icon>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </div>

      <div *ngIf="formData.clientId !== 'tf1Z0TxhbSbpQMzWsAjE'" class="disclaimer">
        <a *ngIf="selectedLanguage === 'fr'" class="disclaimer__link" href="https://welkom.eu" rel="noopener" target="_blank">&nbsp;{{ 'GENERIC.TICKETING_SECURED' | translate }}&nbsp;</a>
        <a *ngIf="selectedLanguage !== 'fr'" class="disclaimer__link" href="https://welkom.eu/en" rel="noopener" target="_blank">&nbsp;{{ 'GENERIC.TICKETING_SECURED' | translate }}&nbsp;</a>
      </div>
    </ion-card>
  </div>

  <ion-grid id="footerGrid">
    <ion-row>
      <ion-col size="12" size-sm="4" class="ion-text-center">
      </ion-col>
      <ion-col size="12" size-sm="4" class="ion-text-center">
        <a [href]="formData.organizerTermsURL" target="_blank" rel="noopener">{{ 'GENERIC.TERMS' | translate }}</a>
        <span class="footerLinkSeparator">.</span>
        <a [href]="formData.organizerPrivacyURL" target="_blank" rel="noopener">{{ 'GENERIC.PRIVACY' | translate }}</a>
      </ion-col>
      <ion-col size="12" size-sm="4" class="alignRight">
        <!-- <a  target="_blank" rel="noopener">English</a>
        <ion-icon name="chevron-down-outline"></ion-icon> -->
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<!-- 
*ngIf="formData.descriptionEnabled && formData.descriptionEnabled === true && formData.descriptionDisplayType === 'popup'"
*ngIf="formData.descriptionEnabled && formData.descriptionEnabled === true && formData.descriptionDisplayType === 'popup'"
 -->
<ion-modal [isOpen]="isDescriptionModalOpen" [backdropDismiss]="false">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ formData.eventName }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="isDescriptionModalOpen = false">{{ 'GENERIC.CLOSE' | translate }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div class="descriptionContent" [innerHTML]="safeDescriptionHtml"></div>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal class="welkomTermsModal" [isOpen]="isWelkomTermsModalOpen" [backdropDismiss]="false" (didDismiss)="isWelkomTermsModalOpen = false">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Welkom</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="isWelkomTermsModalOpen = false">{{ 'GENERIC.CLOSE' | translate }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <article class="welkomTermsContent" *ngIf="selectedLanguage === 'fr'; else welkomTermsEnglish">
        <h2>Conditions Générales d'Utilisation</h2>

        <section>
          <h3>1. Mentions légales et Objet</h3>
          <p>Le présent document définit les conditions d'utilisation du service de billetterie en ligne Welkom par tout acheteur ou visiteur (ci-après "le Visiteur"). Welkom est un service édité par Société Digitale Luxembourgeoise SARL-S, au capital de 1000 euros, immatriculée au registre du commerce sous le numéro B255814, dont le siège social est situé 16 rue Henri Pensis, L-2322 Gasperich, Luxembourg.</p>
        </section>

        <section>
          <h3>2. Rôle de Welkom et Acceptation des CGV de l'Organisateur</h3>
          <p>Welkom agit exclusivement en tant que prestataire technique (logiciel en mode SaaS) fournissant une interface de réservation et d'émission de billets. Welkom n'est ni l'organisateur de l'événement, ni le vendeur des billets, ni un intermédiaire financier.</p>
          <p>En utilisant ce service, le Visiteur reconnaît que le contrat de vente est conclu exclusivement et directement avec l'Organisateur de l'événement. À ce titre, le Visiteur s'engage à prendre connaissance et à accepter sans réserve les Conditions Générales de Vente (CGV) propres à l'Organisateur.</p>
        </section>

        <section>
          <h3>3. Paiement et Sécurité</h3>
          <p>Les transactions financières sont traitées directement entre le Visiteur et le compte de l'Organisateur via le prestataire de services de paiement Mollie (certifié PCI-DSS). Les fonds sont encaissés directement par l'Organisateur. Welkom n'a à aucun moment accès aux données bancaires complètes du Visiteur, ni aux fonds versés lors de la transaction.</p>
        </section>

        <section>
          <h3>4. Annulation, Remboursement et Litiges</h3>
          <p>Puisque Welkom n'encaisse aucun paiement et n'organise pas l'événement, Welkom décline toute responsabilité en cas d'annulation, de report, de modification de l'événement ou de refus d'accès. Toute demande de remboursement, d'exercice du droit de rétractation (si applicable) ou toute réclamation liée au déroulement de l'événement ou à la transaction financière doit être adressée exclusivement et directement à l'Organisateur.</p>
        </section>

        <section>
          <h3>5. Données Personnelles et RGPD</h3>
          <p>Conformément au Règlement Général sur la Protection des Données (RGPD n° 2016/679), Welkom collecte et traite des données à caractère personnel dans le cadre de la réservation de billets. Dans ce contexte, l'Organisateur de l'événement agit en tant que Responsable de Traitement et Welkom agit strictement en tant que Sous-traitant technique. Pour une information complète sur la nature des données collectées, les finalités du traitement, les durées de conservation, l'hébergement (sur infrastructures européennes) et les modalités d'exercice de vos droits, le Visiteur est invité à consulter notre Politique de Confidentialité, ainsi que la politique de confidentialité de l'Organisateur de l'événement.</p>
          <p>Pour plus de détails, veuillez consulter notre Politique de Confidentialité : <a href="https://document.welkom.eu/fr/privacy-v.pdf" target="_blank">https://document.welkom.eu/fr/privacy-v.pdf</a></p>
        </section>

        <section>
          <h3>6. Accès au Service et Responsabilité</h3>
          <p>Welkom met en œuvre les moyens techniques pour assurer la disponibilité de la plateforme de réservation. L'interface est optimisée pour les navigateurs modernes. Welkom ne saurait être tenu responsable d'une indisponibilité du service causée par une défaillance du réseau, du matériel du Visiteur, ou d'un cas de force majeure.</p>
        </section>

        <section>
          <h3>7. Droit applicable et Juridiction</h3>
          <p>Les présentes CGU sont régies par le droit luxembourgeois. Tout litige relatif à l'utilisation technique de la plateforme Welkom relève de la compétence exclusive des juridictions du Grand-Duché de Luxembourg.</p>
        </section>
      </article>

      <ng-template #welkomTermsEnglish>
        <article class="welkomTermsContent">
          <h2>Terms of Use</h2>

          <section>
            <h3>1. Legal Notice and Purpose</h3>
            <p>This document defines the terms of use for the Welkom online ticketing service by any buyer or visitor (hereinafter "the Visitor"). Welkom is a service published by Société Digitale Luxembourgeoise SARL-S, with a share capital of 1,000 euros, registered in the trade register under number B255814, whose registered office is located at 16 rue Henri Pensis, L-2322 Gasperich, Luxembourg.</p>
          </section>

          <section>
            <h3>2. Role of Welkom and Acceptance of the Organiser's General Terms and Conditions of Sale (GTC)</h3>
            <p>Welkom acts exclusively as a technical service provider (SaaS software) providing a booking and ticketing interface. Welkom is neither the event organiser, nor the ticket seller, nor a financial intermediary.</p>
            <p>By using this service, the Visitor acknowledges that the sales contract is concluded exclusively and directly with the Event Organiser. As such, the Visitor agrees to read and unconditionally accept the Organiser's own General Terms and Conditions of Sale (GTC).</p>
          </section>

          <section>
            <h3>3. Payment and Security</h3>
            <p>Financial transactions are processed directly between the Visitor and the Organiser's account via the payment service provider Mollie (PCI-DSS certified). Funds are collected directly by the Organiser. Welkom does not at any time have access to the Visitor's full bank details or to the funds transferred during the transaction.</p>
          </section>

          <section>
            <h3>4. Cancellation, Refunds, and Disputes</h3>
            <p>Since Welkom does not collect any payments and does not organise the event, Welkom declines all responsibility in the event of cancellation, postponement, modification of the event, or refusal of access. Any request for a refund, exercise of the right of withdrawal (if applicable), or any claim related to the running of the event or the financial transaction must be addressed exclusively and directly to the Organiser.</p>
          </section>

          <section>
            <h3>5. Personal Data and GDPR</h3>
            <p>In accordance with the General Data Protection Regulation (GDPR No. 2016/679), Welkom collects and processes personal data as part of the ticket booking process. In this context, the Event Organizer acts as the Data Controller, and Welkom acts strictly as a technical Data Processor. For complete information on the nature of the data collected, the purposes of the processing, the retention periods, the hosting (on European infrastructures), and the procedures for exercising your rights, the Visitor is invited to consult our Privacy Policy, as well as the Event Organizer's privacy policy.</p>
            <p>For more details, please consult our Privacy Policy: <a href="https://document.welkom.eu/fr/privacy-v.pdf" target="_blank">https://document.welkom.eu/fr/privacy-v.pdf</a></p>
          </section>

          <section>
            <h3>6. Service Access and Liability</h3>
            <p>Welkom implements the technical means to ensure the availability of the booking platform. The interface is optimized for modern web browsers. Welkom cannot be held liable for service unavailability caused by a network failure, the Visitor's hardware, or an event of force majeure.</p>
          </section>

          <section>
            <h3>7. Applicable Law and Jurisdiction</h3>
            <p>These Terms of Use are governed by Luxembourg law. Any dispute relating to the technical use of the Welkom platform falls under the exclusive jurisdiction of the courts of the Grand Duchy of Luxembourg.</p>
          </section>
        </article>
      </ng-template>
    </ion-content>
  </ng-template>
</ion-modal>


<!-- <ion-modal id="qrModal" [isOpen]="isQRModalOpen" [backdropDismiss]="false">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Use this QR code to log in to Welkom Access</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="closeQRModal()">Close</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <img [src]="qrCodeSrc" />
    </ion-content>
  </ng-template>
</ion-modal> -->